import { CdkStepper } from '@angular/cdk/stepper';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ElementRef, HostListener, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormatSettings } from '@progress/kendo-angular-dateinputs';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { SignaturePad } from 'angular2-signaturepad';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { CreditCard, CreditCardValidators } from 'angular-cc-library';

import { CLPUser, TeamCodes, TeamResponse, UserResponse } from '../../models/clpuser.model';
import { CMContractNav, CMContractNavListResponse, CMNavigation, CMNavigationResponse, Contact, ContactDetails, CMContract, ContractResponse, eCMNavigation_Update_Type, CC, Bank, CheckCash, Charge, ContractAcceptation, eContractFeeType, CMPaymentTxnResponse, CMPaymentTxn, CMPaymentTxnNoFee, CMContractFeeListResponse, CMContractFee, CMMemberFeeListResponse, CMMemberFee, PaymentReviewListResponse, PaymentReview, CMPaymentItem, CMPaymentItem_Charge, PayListResponse, Pay, FeeItem, ContractPdfConvertContainer, RetrieveCardResponse, RetrieveBankResponse, Card, CMContractLog, CMSession, VendorCustrReq, eREF_CMContractStatus, eREF_CMMemberStatus } from '../../models/cm-contract';
import { DropDownItem, SimpleResponse, UserDD } from '../../models/generic-response.model';
import { CMContractSetting, CMContractSettingResponse } from '../../models/cm-contract';
import { RoleFeaturePermissions } from '../../models/role-container.model';

import { CMContractService } from '../../services/cm-contract.service';
import { CountryStateService } from '../../services/country-state.service';
import { NotificationService } from '../../services/notification.service';
import { PaymentService } from '../../services/payment.service';
import { GlobalService } from '../../services/shared/global.service';
import { LocalService } from '../../services/shared/local.service';
import { UtilityService } from '../../services/shared/utility.service';
import { Title } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';
import { FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';
import { CountryPlaceholder } from '../../models/country-state.model';
import { CountryCode } from 'libphonenumber-js';
import { CMClubService } from '../../services/cm-club.service';
import { CMClubResponse, SiteDDListResponse, CMSite } from '../../models/cm-club-service.model';
import { ItemChange } from '@progress/kendo-angular-charts/common/collection.service';

//For jquery
declare var $: any;

@Component({
    selector: 'app-cm-contract-client',
    templateUrl: './cm-contract-client.component.html',
    styleUrl: './cm-contract-client.component.css'
})
export class CmContractClientComponent implements OnDestroy, AfterViewInit {
    @ViewChild('iframeRef') iframeRef!: ElementRef<HTMLIFrameElement>;
    @ViewChild('outerContainerDocRef') outerContainerDocRef!: ElementRef<HTMLIFrameElement>;
    encryptedUser: string = '';
    userResponse: UserResponse;
    user: CLPUser;
    userAI: CLPUser;
    roleFeaturePermissions: RoleFeaturePermissions;
    teamFilterDD: TeamCodes[];
    userList: UserDD[] = [{
        value: 0,
        text: "Select",
    }];
    clubConfigForm: FormGroup

    teamCodeDetails: TeamResponse;

    filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains',
    };

    showSpinner: boolean;
    isDownload: boolean = false;
    isDownloaded: boolean = false;
    isPreviewDownloaded: boolean = false;
    selectedUser: string;
    curTeam: TeamCodes = <TeamCodes>{};
    curTeamCode: number = 0
    isBtnDisabled: boolean;
    private teamSub: Subscription;
    private clubIdSub: Subscription;
    submitted: boolean;
    clpCompanyId: number;
    slurpyUserId: number;
    userRole: number;
    @ViewChild('stepper') stepper: CdkStepper;
    @ViewChild('sigpadFinal', { static: true }) signaturePadFinal: SignaturePad;
    @ViewChild('sigpad2', { static: true }) signaturePad2: SignaturePad;
    contactForm: FormGroup;
    productDocsGroup: FormGroup;
    countryDD: CountryPlaceholder[];
    stateList: DropDownItem[];

    countryCode: string = "USA";
    stateCode: string = "";
    sel_brand: string = "unknown";
    isContractReview: boolean = false;
    public format: FormatSettings = {
        displayFormat: 'MM/dd/yyyy',
        inputFormat: 'MM/dd/yy'
    };
    public signataurePadOptionsFinal = {
        'minWidth': 1,
        'maxWidth': 2,
        'minHeight': 150,
        'maxHeight': 200,
        penColor: 'black',
        backgroundColor: '#fff',
    };
    contactId: number;
    contactEmail: string;
    vendorCustomerId: string;
    vendorCustomerId2: string;
    vCustomerIdPrimary: string;
    memberFeeId: number = 0;
    contactDetails: any = [];
    contacts: ContactDetails[];
    contact: ContactDetails = <ContactDetails>{};
    contractSetting: CMContractSetting = <CMContractSetting>{};
    contactData: Contact = <Contact>{};
    contractId: number = 0;

    userId: number;
    contactPaymentComplete: boolean;

    contracts: CMContract[];
    contract: CMContract;
    contractNavList: CMContractNav[];
    contractList = {} as CMContractNav;
    navigation = {} as CMNavigation;
    currentActive: string = '15';
    isSocDone: boolean = false;
    isFinalSignDone: boolean = false;
    isProductConfig: boolean = false;
    isCollection: boolean = false;
    paymentForm: FormGroup;
    paymentCollection: FormGroup;
    memberFees: CMMemberFee[];
    memberFee = {} as CMMemberFee;
    siteId: number = 0;
    memberId: number = 0;
    stepId: string = "";
    productDoc: string = "The document is loading. Please wait...";
    docTitle: string = '';
    isProductDoc: boolean = false;
    person: string;
    signature: string = '';
    initialFinalDisabled: boolean = false;
    initial2Disabled: boolean = false;
    titleMsg = '';
    isExistFinal: boolean = false;
    base64StrFinal: string;

    isShowCCForm: boolean;
    isShowCheckForm: boolean;
    progressPreFetch: number = 0;
    payType: string = "";
    docId: number = 0;
    unixDate: number;
    isSignaturePad: boolean = true;
    cFirstName: string = '';
    cLastName: string = '';
    uName: string = '';


    card: CreditCard;
    @ViewChild('creditCard', { static: true }) creditCard_element;

    ccForm: FormGroup;
    bankForm: FormGroup;
    contractAcceptation = {} as ContractAcceptation;
    paymentTrxs: CMPaymentTxn[] = [];
    paymentTrxsFinal: CMPaymentTxn[] = [];
    transactionId: number = 0;
    totalBeingPaid: number = 0.00;
    displayBeingPaid: string = '';
    isPayment: boolean = false;
    paymentReview: PaymentReview[];
    delTransId: number = 0;
    allCardPayments: any = []
    isAllPayDone: boolean = false
    cmPaymentItem = {} as CMPaymentItem;
    contractFees: CMContractFee[];
    cmPaymentItems: CMPaymentItem[]
    outStandingAmount: number;
    contractNavCopy: CMContractNav[] = []
    paymentState: any = []
    lastPaymentId: string = ''
    lastPaymentId2: string = ''
    paymentChargeItems: Pay[];
    paySourceDD: any[] = [];
    isPaySetup: boolean = true

    disableDetailsSave: boolean = false;
    mobile_mask: string = '(000) 000-0000';

    isUserVerified = false
    verifyUserForm: FormGroup
    placeHolder: string = "";
    isSubscribe: any;
    contractUrl: string = '';
    contractPdfConvertContainer: ContractPdfConvertContainer;

    isAllDocAccepted: boolean = false
    toggleMobileMenu: boolean = false;

    lastcMPaymentTxnID: number = -1;
    chargeFailed: boolean = false;
    editCardPayTxnId: number;
    editCardDetails: Card;
    isForPreviewDownload: boolean = false;

    pay_download: boolean = true;
    sessionId: string = '';
    startF2F: boolean = true;
    is_client: boolean = false;
    dlFront: File;
    dlBack: File;
    uploadRestrictions: FileRestrictions = {
        allowedExtensions: [".jpg", ".png", ".jpeg"],
        maxFileSize: 5242880
    };
    placeholder: string = ''
    isPrimaryMem: boolean = false;

    deposit: number = 0;
    depositBase: number = 0;
    depositTax: number = 0;
    depositSurcharge: number = 0;
    depositSummary: string = '';
    depositSummaryFee: string = '';
    classCode1: number = 0;
    siteList: CMSite[];
    site: CMSite = <CMSite>{};
    taxRate: number;
    previouslyEditedIndex: number | null = null;
    private destroy$ = new Subject<void>();
    terminate: boolean = false;
    isDocLoaded: boolean = false;
    vendorCustomerIdLoaded: boolean = false;

    constructor(private _localService: LocalService,
        private _utilityService: UtilityService,
        private fb: FormBuilder,
        private _notifyService: NotificationService,
        private _globalService: GlobalService,
        private _countryStateService: CountryStateService,
        private _contractService: CMContractService,
        private _paymentService: PaymentService,
        private _route: ActivatedRoute,
        private renderer: Renderer2,
        private _clubService: CMClubService,
        private titleService: Title,
        public datepipe: DatePipe,
    ) {
        this.titleService.setTitle('Contract');
        this._localService.setShowMenu(false);
        this._localService.setIsContract(false);
        this._localService.setIsClientContract(true);
        this._localService.setRouteName("cm-contract-client");
        this._localService.setIsCmSite(false);
        this._localService.setIsCmManager(false);
        this._localService.setIsMembership(false);
    }

    ngAfterViewInit(): void {
        this.resizeCanvas();
    }

    ngOnInit() {

        this.contactForm = this.prepareContactForm();
        this.paymentForm = this.preparePaymentForm();
        this.productDocsGroup = this.prepareDocForm();
        this.paymentCollection = this.prepareCollectionForm();
        this.ccForm = this.prepareCCForm();
        this.bankForm = this.prepareBankForm();
        this.verifyUserForm = this.prepareVerifyUserForm();
        this.ccForm.reset();
        this.bankForm.reset();

        //if (localStorage.getItem("isAI")) {
        //    this.isAI = localStorage.getItem("isAI") == 'true' ? true : false;
        //}
        //else {
        //    if (document.location.host.endsWith('ai') || document.location.host.endsWith('315')) {
        //        this.isAI = true;
        //    }
        //}

        this._route.paramMap.pipe(takeUntil(this.destroy$)).subscribe(queryParams => {
            this.contactId = +queryParams.get('contactId');
            this.contractId = +queryParams.get('contractId');
            this.userId = +queryParams.get('userId');

            if (this.userId > 0) {
                this.isUserVerified = true;
                this.is_client = false;
                this.authenticate();
            }
            else {
                //UserId will be 0 on independent links;
                this.is_client = true;
                $('#verifyUserModal').modal('show');
                this.authenticate();
            }
        });
        this.resizeCanvas();
    }

    authenticate() {
        this.authenticateR(this.contactId).then(async () => {
            if (this.encryptedUser) {
                if (this.contracts?.length > 0) {
                    this.unixTimestamp()
                    //localStorage.setItem("token", this.encryptedUser); //this would overwrite the contract.component write (with slurpy user getting overwritten)
                    this.loadPage();
                    //this.getContractFee();
                } else {
                    $('#contractNotFound').modal('show');
                }
            }
        });
    }

    private prepareVerifyUserForm(): FormGroup {
        return this.fb.group({
            email: ['', [Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            mobile: [''],
        });
    }

    async verifyUser() {
        if (this.verifyUserForm.controls['mobile'].value == '' && this.verifyUserForm.controls['email'].value == '') {
            this._notifyService.showError("Either your Mobile phone or Email address is required.", "", 10000);
            return;
        }

        if (this.verifyUserForm.valid) {
            let email = this.verifyUserForm.controls['email'].value
            let mobile = this.verifyUserForm.controls['mobile'].value
            await this._localService.validateContact(this.contactId, this.contractId, email, mobile).
                then(async (result: SimpleResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        if (response.messageBool) {
                            this.isUserVerified = true
                            this.addTimeout(() => {
                                this.resizeCanvas();
                            }, 2000)
                            this.getCurrentLocation();
                        }
                        else {
                            this._notifyService.showError("We didn't recognize what you gave us. Please try again.", "", 10000);
                        }

                        this.verifyUserForm.controls['email'].patchValue('');
                        this.verifyUserForm.controls['mobile'].patchValue('');
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("cm-contract.verifyUser", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    private async authenticateR(contactId) {
        await this._localService.authenticate(this.encryptedUser, this.userId, contactId)
            .then(async (result: UserResponse) => {
                if (result) {
                    this.user = UtilityService.clone(result?.user);
                    this.clpCompanyId = this.user?.cLPCompanyID;
                    this.encryptedUser = result?.encryptedToken;
                    this.cFirstName = result?.cFirstName;
                    this.cLastName = result?.cLastName;
                    this.uName = this.user?.firstName + ' ' + this.user?.lastName;
                    await this.getContractDetails();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    preparePaymentForm() {
        return this.fb.group({
            //cMPaymentTxnID: ["-1"],
            payFee: ["$0.00"],
            contractFee: ["$0.00"],
            paymentMethods: this.fb.array([]),
            totalPrice: ["$0.00"],
            membershipFee: ["$0.00"],
            paycharge: [''],
            //---credit card----
            ccFirstName: [''],
            ccLastName: [''],
            ccNumber: [''],
            ccDtExpire: [''],
            ccCVC: [''],
            ccZipCode: [''],
            //---Cheque or ACH----
            aBANum: [''],
            aCNum: [''],
            aCType: [''],
            financialInstitute: [''],
            businessName: [''],
            aCHolderName: [''],
            aCPhone: [''],
            aCEmail: [''],
            aCAddress: [''],
            aCCity: [''],
            aCZip: [''],
            aCState: [''],
            aCCountry: [''],
        })
    }

    prepareDocForm() {
        return this.fb.group({
            initialFinalSignature: [''],
            initial: ['']
        })
    }

    prepareCollectionForm() {
        return this.fb.group({
            isCollection: [false],
        })
    }

    newPaymentMethod(): FormGroup {
        return this.fb.group({
            paymentSource: 1,
            totalAmount: 0.00,
        })
    }

    removePaymentMethod(fee, index: number): void {
        if (this.paymentMethods?.length > 1) {
            this.paymentMethods.removeAt(index);
        }

        let stIndex = this.paymentState.findIndex((ind) => ind?.cMPaymentTxnID == fee?.value.cMPaymentTxnID)
        if (stIndex != -1) {
            this.paymentState.splice(index, 1);
        }

        this.onChangeAmount(false)
    }

    async addPaymentMethod() {
        this.CheckSession(async () => {
            let _paymentSource = this.fb.group({
                cMPaymentItemID: 0,
                cMContractFeeID: 0,
                //cMPaymentTxnID: this.paymentTrxs[0]?.cMPaymentTxnID > 0 ? this.paymentTrxs[0]?.cMPaymentTxnID : -1,
                cMPaymentTxnID: -1,
                feeAmount: "$0.00",
                paymentType: this.paymentTrxs[0]?.paymentType > 0 ? this.paymentTrxs[0]?.paymentType : 0,
                isPaymentDone: false
            });
            await this.paymentMethods.push(_paymentSource);

            await this.splitEvenly()
            this.holdPayState();
            this.Log(`<b>Split payment</b> clicked.`);
        });
    }

    prepareContactForm() {
        return this.fb.group({
            txtFirstName: ['', [Validators.required, this.nameValidator]],
            txtLastName: ['', [Validators.required, this.nameValidator]],
            txtEmail: ['', [Validators.required, Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            txtMobilePhone: ['', [Validators.required]],
            txtHomePhone: [''],
            txtAddress: ['', [Validators.required]],
            txtCity: ['', [Validators.required]],
            txtState: ['', [Validators.required]],
            txtCountry: ['USA', [Validators.required]],
            txtZip: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(9)]],
            dl: ['', [Validators.required]],
            dob: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[0-2])(0[1-9]|1\d|2\d|3[01])(19|20)\d{2}$/)]],
            emgContactName: ['', [Validators.required]],
            txtEmgCntPhone: ['', [Validators.required]],
        })
    }

    nameValidator(control: any) {
        const value = control.value;
        const namePattern = /^[a-zA-Z\s'-]+$/;
        return namePattern.test(value) ? null : { 'invalidName': true };
    }

    @HostListener('window:scroll', ['$event'])
    checkOffsetTop() {
        if (this.stepper) {
            if (this.stepper?.selectedIndex == 0) {
            }
        }
    }

    async loadPage() {
        this.getCountry();
        await this.navigationGet();
        this.productGet(false);
        await this.getContactData(false);
        await this.getVendorCustomerId()
        this.cMPaymentTxn_Load();
        this.getContractFee();
        this.cMPaymentItem_Charge_Get(true);
        this.ContractOpenAutomation();
        this.createAgreementCard();

    }

    async createAgreementCard() {
        await this._contractService.addAgreementOpenLCCard(this.encryptedUser, this.contactId, this.user.cLPUserID).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.createAgreementCard", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });

    }

    async getVendorCustomerId() {
        let vendorCustrReq = <VendorCustrReq>{}
        vendorCustrReq.cmMemberId = this.memberId
        vendorCustrReq.contactId = this.contactId
        vendorCustrReq.contractId = this.contractId
        vendorCustrReq.email = this.contactEmail

        await this._paymentService.getVendorCustomerId(this.encryptedUser, vendorCustrReq).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response.messageString != '') {
                        this.vendorCustomerId = response.messageString;
                        this.vendorCustomerId2 = response.messageString2;
                        this.vCustomerIdPrimary = response.messageString3;
                        this.vendorCustomerIdLoaded = true;

                    }
                    else {
                        this._notifyService.showError("A problem occurred connecting to the payment vendor. Please refresh this page or contact your Sales Representative.", "", 0);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getVendorCustomerId", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    onChangeCountry(countryCode) {
        this.stateCode = "";
        this.ccForm.controls['state'].setValue("")
        this.bankForm.controls['accountState'].setValue("")
        this.getCountryStateList(countryCode);
        var country_Code = this.countryDD.filter(x => x.country_Code == countryCode)[0]?.country_Code;
        this.placeholder = this.countryDD.filter(x => x.country_Code == countryCode)[0]?.placeholder;

        if (country_Code && this.placeholder) {
            this.placeHolder = this._countryStateService.parseSimplePhone(this.placeholder, country_Code as CountryCode);
            this.mobile_mask = this._countryStateService.replaceZero(this.placeHolder);
        }
    }

    async getCountry() {
        await this._countryStateService.getListWithPlaceholder(this.encryptedUser)
            .then(async (result: CountryPlaceholder[]) => {
                if (result) {
                    this.countryDD = UtilityService.clone(result);
                    this.countryDD?.unshift({
                        country_Code: "",
                        country_Name: "--Select--",
                        placeholder: "",
                        country_Code2: ""
                    });
                    this.onChangeCountry(this.countryCode)
                }

            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getCountryStateList(countryCode: string) {
        await this._countryStateService.getCountryStateList(this.encryptedUser, countryCode ? countryCode : "USA")
            .then(async (result: DropDownItem[]) => {
                if (result) {
                    this.stateList = UtilityService.clone(result);
                    this.stateList?.unshift({
                        value: "",
                        text: "--Select--",
                        isSelected: false
                    });
                }
            })
            .catch((err: HttpErrorResponse) => {
                console.log(err);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getContactData(isAccept: boolean = false) {
        this.showSpinner = true;
        await this._contractService.LoadContractMemberDisplay(this.encryptedUser, this.contactId).
            then(async (result: any) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response) {
                        this.contactDetails = response;
                        this.patchContactDetails();
                        this.isSocDone = true;
                        this.isProductDoc = false;
                        this.classCode1 = this.contactDetails.class1Codes;

                        this.getSiteData();

                        this.contactEmail = this.contactDetails?.email;
                        if (this.countryDD.some(item => item.country_Name === this.contactDetails.country)) {
                            var country_Code = this.countryDD.find(item => item.country_Name === this.contactDetails.country).country_Code
                            this.contactForm.controls['txtCountry'].patchValue(country_Code);
                        }
                        if (this.stateList?.some(item => item.text === this.contactDetails.state)) {
                            var state = this.stateList.find(item => item.text === this.contactDetails.state).value
                            this.contactForm.controls['txtState'].patchValue(state);
                        }

                        if (this.navigation?.isDLUploaded) {
                            //this.showDivItem(this.stepper, '#tdPay', '20', null, false, 3);
                            this.showDivItem(this.stepper, '#tdDLUpload', '21', null, false, 3);
                            this.ProcessorContractPDFConvert_Add();
                        }
                        else {
                            this.currentActive = '15';
                            if (isAccept)
                                this.showDivItem(this.stepper, '#product', 'd' + this.contractNavList[0]?.cMContractNavID, null, false, 1, 0);
                        }
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("cm-contract.getContactData", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    patchContactDetails() {
        this.contactForm.controls['txtFirstName'].patchValue(this.contactDetails?.firstName);
        this.contactForm.controls['txtLastName'].patchValue(this.contactDetails?.lastName);
        this.contactForm.controls['txtEmail'].patchValue(this.contactDetails?.email);
        this.contactForm.controls['txtMobilePhone'].patchValue(this.contactDetails?.mobile);
        this.contactForm.controls['txtHomePhone'].patchValue(this.contactDetails?.homePhone);
        this.contactForm.controls['txtAddress'].patchValue(this.contactDetails?.add1);
        this.contactForm.controls['txtCity'].patchValue(this.contactDetails?.city);
        this.contactForm.controls['txtState'].patchValue(this.contactDetails?.state);
        this.contactForm.controls['txtCountry'].patchValue(this.setCountryDD(this.contactDetails?.country ? this.contactDetails?.country : "USA"));
        this.contactForm.controls['txtZip'].patchValue(this.contactDetails?.zip);
        this.contactForm.controls['dl'].patchValue(this.contactDetails?.dl);
        this.contactForm.controls['dob'].patchValue(this.cleanDateObject(this.contactDetails?.dob));
        this.contactForm.controls['emgContactName'].patchValue(this.contactDetails?.emergencyCName);
        this.contactForm.controls['txtEmgCntPhone'].patchValue(this.contactDetails?.emergencyCPhone);
    }

    setCountryDD(country) {
        if (this.countryDD?.length > 0) {
            let code = this.countryDD?.filter((item) => item?.country_Code?.toLowerCase() == country?.toLowerCase() || item?.country_Name?.toLowerCase() == country?.toLowerCase() || item?.country_Code2?.toLowerCase() == country?.toLowerCase())[0]?.country_Code2;
            if (code) {
                return code;
            }
        }
        return "";
    }

    hasObjectChanged(oldObj: any, newObj: any): boolean {
        const oldKeys = Object.keys(oldObj);
        const newKeys = Object.keys(newObj);

        const commonKeys = oldKeys.filter(key => newKeys.includes(key));

        for (const key of commonKeys) {
            if (oldObj[key] !== newObj[key]) {
                return true;
            }
        }

        return false;
    }

    async saveContact() {
        this.CheckSession(async () => {
            this.disableDetailsSave = true;
            this.validateAllFormFields(this.contactForm);

            this.prepareContact();
            if (this.contactForm.valid) {
                this.showSpinner = true
                await this._contractService.CMContact_Save(this.encryptedUser, this.contactData, 0, false).
                    then(async (result: SimpleResponse) => {
                        if (result) {
                            this.showSpinner = false
                            let response = UtilityService.clone(result);
                            if (response.messageInt > 0) {
                                this.contactId = response.messageInt;
                                let isAnyValueChanged = this.hasObjectChanged(this.contactData, this.contactDetails)
                                if (isAnyValueChanged) {
                                    this.productGet(false)
                                    this.getContactData(false);
                                }
                                else {
                                    this.getContactData(true);
                                }
                                this.navigationUpdate(eCMNavigation_Update_Type.isDetails, true);
                                this._notifyService.showSuccess("Your details have been saved.", "", 7000)
                                this.Log(`Verify: <b>Save & Continue</b> (Personal Information) clicked and saved.`);
                                this.cmMemberStatus(eREF_CMMemberStatus.Info_Update, null);
                                this.disableDetailsSave = false;
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.showSpinner = false;
                        this.disableDetailsSave = false;
                        this._globalService.error("cm-contract.CMContact_Create", err.message, null,
                        );
                        this._utilityService.handleErrorResponse(err);
                        this.Log(`Verify: <b>Save & Continue</b> (Personal Information) clicked. Error. ${err.message}`);
                    });
            }
            else {
                this.disableDetailsSave = false;
                this._notifyService.showError("Please fill mandatory fields.", "", 10000)
                this.Log('Verify: <b>Save & Continue</b> (Personal Information) clicked. Invalid information. Not Saved.');
            }
        });
    }

    cleanDateObject(date: string): string {
        if (!date) return '';

        // Remove time portion if present
        const datePart = date.split(' ')[0]; // "1/18/2000"
        const parts = datePart.split('/');

        if (parts.length !== 3) return '';

        let [month, day, year] = parts;
        // Pad with zeros if needed
        if (month.length === 1) month = '0' + month;
        if (day.length === 1) day = '0' + day;

        return `${month}${day}${year}`;
    }

    getDateObject(date: string) {
        const month = date.substring(0, 2); // Month is zero-based
        const day = date.substring(2, 4);
        const year = date.substring(4, 8);

        return `${month}/${day}/${year}`;
    }

    async cMContractNavCreate() {
        await this._contractService.cMContractNavCreate(this.encryptedUser, this.contractId, this.contactId).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response.messageInt > 0) {

                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.cMContractNavCreate", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async navigation_Create() {
        await this._contractService.navigation_Create(this.encryptedUser, this.contractId, this.contactId).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response.messageInt > 0) {
                        this.navigationGet();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.navigation_Create", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async navigationUpdate(navType: eCMNavigation_Update_Type, isNavValue: boolean) {
        this.showSpinner = true
        await this._contractService.navigationUpdate(this.encryptedUser, this.navigation.cMNavigationID, navType, isNavValue).
            then(async (result: SimpleResponse) => {
                if (result) {
                    this.showSpinner = false
                    let response = UtilityService.clone(result);
                    if (response.messageInt > 0) {
                        this.navigationGet();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract-client.navigationUpdate", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async loadDocs(cmroductDocId, cmContractNavID) {
        return this._contractService.productGet(this.encryptedUser, this.clpCompanyId, this.contractId, this.contactId, cmroductDocId, cmContractNavID).
            then(async (result: CMContractNavListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response && response?.cmContractNav.length > 0) {
                        let contractNav = response?.cmContractNav[0];
                        if (this.contractNavCopy?.some(c => c.cMContractNavID == contractNav.cMContractNavID) == false)
                            this.contractNavCopy.push(contractNav);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.productGet", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    redirectNav(isRedirect) {
        this.unixTimestamp();
        this.addTimeout(() => {
            this.setProgressBar();
        }, 100);

        if (isRedirect) {
            let isDoc = false;
            for (var i = 0; i < this.contractNavList.length; i++) {
                if (this.contractNavList[i].isAccepted)
                    isDoc = true;
                else {
                    isDoc = false;
                    if (this.contractNavList[i].cMContractNavID != this.docId) {
                        this.showDivItem(this.stepper, '#product', 'd' + this.contractNavList[i].cMContractNavID, this.contractNavList[i], false, 1, i);
                        return;
                    }
                }
            }
            if (isDoc) {
                if (this.memberFees?.length > 0) {
                    this.showDivItem(this.stepper, '#tdFee', 'p' + this.memberFees[0]?.cmMemberFeeID, this.memberFees[0], false, 2);

                }
                else {
                    if (this.paymentReview?.length > 0) {
                        this.showDivItem(this.stepper, '#tdReview', '19', null, false, 3);
                    }
                    else {
                        this.navigationUpdate(eCMNavigation_Update_Type.isReview, true).then(() => {
                            this.navigationUpdate(eCMNavigation_Update_Type.isPaymentCollect, true).then(() => {
                                //if contract's current status is 3 then do this:
                                if (this.contract.statusID == 3) {
                                    if (this.isContractReview) {
                                        this.cmContractStatus(eREF_CMContractStatus.OnHold_Review);
                                    }
                                    else {
                                        this.cmContractStatus(eREF_CMContractStatus.Waiting_CounterSign);
                                    }
                                }

                                this.showDivItem(this.stepper, '#tdDLUpload', '21', null, false, 3);
                            });
                        });
                    }
                }

            }
        }
    }

    async productGet(isRedirect: boolean = false) {
        this.isDocLoaded = true;
        await this._contractService.productGet(this.encryptedUser, this.clpCompanyId, this.contractId, this.contactId, 0, 0).
            then(async (result: CMContractNavListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response && response?.cmContractNav.length > 0) {
                        this.contractNavList = response?.cmContractNav;

                        this.contractList = this.contractNavList.filter(x => x.cMContractNavID == this.docId)[0];

                        this.unixTimestamp();
                        this.addTimeout(() => {
                            this.setProgressBar();
                        }, 100);

                        this.addTimeout(() => {
                            this.getCurrentLocation();
                        }, 500);

                        if (isRedirect) {
                            let isDoc = false;
                            for (var i = 0; i < this.contractNavList.length; i++) {
                                if (this.contractNavList[i].isAccepted)
                                    isDoc = true;
                                else {
                                    isDoc = false;
                                    if (this.contractNavList[i].cMContractNavID != this.docId) {
                                        this.showDivItem(this.stepper, '#product', 'd' + this.contractNavList[i].cMContractNavID, this.contractNavList[i], false, 1, i);
                                        return;
                                    }
                                }
                            }
                            if (isDoc)
                                this.showDivItem(this.stepper, '#tdFee', 'p' + this.memberFees[0]?.cmMemberFeeID, this.memberFees[0], false, 2);

                        }
                    }

                    this.isDocLoaded = false;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isDocLoaded = false;
                this._globalService.error("cm-contract.productGet", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async navigationGet() {
        this.showSpinner = true;
        await this._contractService.navigationGet(this.encryptedUser, this.contractId, this.contactId).
            then(async (result: CMNavigationResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response && response?.cMNavigation.cMNavigationID > 0) {
                        this.navigation = response?.cMNavigation;

                        this.addTimeout(() => {
                            this.setProgressBar();
                        }, 100);
                    }
                    else {
                        this.navigation_Create();
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("cm-contract-client.navigationGet", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    setProgressBar() {
        if (this.contractNavList?.length > 0) {
            const totalProduct = (this.contractNavList?.length + 4) + (this.memberFees?.length);
            if (totalProduct > 0) {
                this.progressPreFetch = 0;
                this.navigation.isDetails ? this.getProgressBar(100 / totalProduct) : 0;
                this.navigation.isSignUpFee ? this.getProgressBar(100 / totalProduct) : 0;
                this.navigation.isMembershipFee ? this.getProgressBar(100 / totalProduct) : 0;
                this.navigation.isClubsideFee ? this.getProgressBar(100 / totalProduct) : 0;
                this.navigation.isReview ? this.getProgressBar(100 / totalProduct) : 0;
                this.navigation.isPaymentCollect ? this.getProgressBar(100 / totalProduct) : 0;
                this.navigation.isDLUploaded ? this.getProgressBar(100 / totalProduct) : 0;
                this.contractNavList.forEach((item) => {
                    if (item.isAccepted)
                        this.getProgressBar(100 / totalProduct);
                });
                this.memberFees.forEach((mem) => {
                    if (mem.isDone)
                        this.getProgressBar(100 / totalProduct);
                });
            }
        }
    }

    getCurrentLocation() {
        if (this.contractNavList?.length > 0) {
            const totalProduct = (this.contractNavList?.length + 3) + (this.memberFees?.length);
            if (totalProduct > 0) {
                if (!this.navigation.isDetails) {
                    this.showDivItem(this.stepper, '#tdIsSOCDoc', '15', null, false, 0)
                }
                else {
                    let latest_doc = null;
                    let doc_position = -1;
                    let latest_doc_position = -1;

                    this.contractNavList.forEach((item) => {
                        doc_position++;

                        if (!item.isAccepted && !latest_doc) {
                            latest_doc = item;
                            latest_doc_position = doc_position;
                        }
                    });

                    if (latest_doc) {
                        this.showDivItem(this.stepper, '#product', 'd' + latest_doc?.cMContractNavID, null, false, 1, latest_doc_position, this.userId == 0 ? false : true);
                    }
                    else {
                        let latest_pay = null;

                        this.memberFees.forEach((item) => {

                            if (!item.isDone && !latest_pay) {
                                latest_pay = item;
                            }
                        });

                        if (latest_pay) {
                            if (this.memberFees?.length > 0) {
                                this.showDivItem(this.stepper, '#tdFee', 'p' + latest_pay?.cmMemberFeeID, latest_pay, false, 2);
                            }
                            else {
                                if (this.paymentReview?.length > 0) {
                                    this.showDivItem(this.stepper, '#tdReview', '19', null, false, 3);
                                }
                                else {
                                    this.navigationUpdate(eCMNavigation_Update_Type.isReview, true);
                                    this.navigationUpdate(eCMNavigation_Update_Type.isPaymentCollect, true);
                                    this.showDivItem(this.stepper, '#tdDLUpload', '21', null, false, 3);
                                }
                            }

                        }
                        else {
                            if (!this.navigation.isReview) {
                                if (this.paymentReview?.length > 0) {
                                    this.showDivItem(this.stepper, '#tdReview', '19', null, false, 3);
                                }
                                else {
                                    if (!this.terminate) {
                                        this.navigationUpdate(eCMNavigation_Update_Type.isReview, true);
                                        this.navigationUpdate(eCMNavigation_Update_Type.isPaymentCollect, true);
                                        this.showDivItem(this.stepper, '#tdDLUpload', '21', null, false, 3);
                                    }
                                    else {
                                        this.showDivItem(this.stepper, '#tdReview', '19', null, false, 3);
                                    }
                                }
                            }
                            else {
                                if (!this.navigation.isPaymentCollect) {
                                    this.showDivItem(this.stepper, '#tdPay', '20', null, false, 3);
                                }
                                else {
                                    this.showDivItem(this.stepper, '#tdDLUpload', '21', null, false, 3);
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    cc_brand_id(e) {
        var jcb_regex = new RegExp('^(?:2131|1800|35)[0-9]{0,}$');
        var amex_regex = new RegExp('^3[47][0-9]{0,}$'); //34, 37
        var diners_regex = new RegExp('^3(?:0[0-59]{1}|[689])[0-9]{0,}$');
        var visa_regex = new RegExp('^4[0-9]{0,}$'); //4
        var mastercard_regex = new RegExp('^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$');
        var maestro_regex = new RegExp('^(5[06789]|6)[0-9]{0,}$');
        var discover_regex = new RegExp('^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$');

        //var cur_val = this.paymentConfigureForm.controls.ccNumber.value;

        //cur_val = cur_val.replace(/\D/g, '');
        //var sel_brand = "unknown";
        //if (cur_val.match(jcb_regex)) {
        //    sel_brand = "jcb";
        //} else if (cur_val.match(amex_regex)) {
        //    sel_brand = "amex";
        //} else if (cur_val.match(diners_regex)) {
        //    sel_brand = "diners_club";
        //} else if (cur_val.match(visa_regex)) {
        //    sel_brand = "visa";
        //} else if (cur_val.match(mastercard_regex)) {
        //    sel_brand = "mastercard";
        //} else if (cur_val.match(discover_regex)) {
        //    sel_brand = "discover";
        //} else if (cur_val.match(maestro_regex)) {
        //    if (cur_val[0] == '5') {
        //        sel_brand = "mastercard";
        //    } else {
        //        sel_brand = "stripe";
        //    }
        //}

        //this.sel_brand = sel_brand;
    }


    prepareContact() {
        this.contactData.contactID = this.contactId
        this.contactData.firstName = this.contactForm.controls["txtFirstName"].value;
        this.contactData.lastName = this.contactForm.controls["txtLastName"].value;
        this.contactData.email = this.contactForm.controls["txtEmail"].value;
        this.contactData.mobile = this.contactForm.controls["txtMobilePhone"].value;
        this.contactData.homePhone = this.contactForm.controls["txtHomePhone"].value;
        this.contactData.add1 = this.contactForm.controls["txtAddress"].value;
        this.contactData.city = this.contactForm.controls["txtCity"].value;
        this.contactData.zip = this.contactForm.controls["txtZip"].value;
        this.contactData.state = this.contactForm.controls["txtState"].value;
        this.contactData.country = this.contactForm.controls["txtCountry"].value;
        this.contactData.dl = this.contactForm.controls["dl"].value;
        this.contactData.dob = this.getDateObject(this.contactForm.controls["dob"].value);
        this.contactData.emergencyCName = this.contactForm.controls["emgContactName"].value;
        this.contactData.emergencyCPhone = this.contactForm.controls["txtEmgCntPhone"].value;
        this.contactData.cLPUserID = this.user.cLPUserID;
        this.contactData.cLPCompanyID = this.user.cLPCompanyID;
        this.contactData.siteId = this.siteId;
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched();
            }
        });
    }

    async getContractSetting() {
        await this._contractService.cmSiteContractSetting_Get(this.encryptedUser, this.contracts[0]?.siteID).
            then(async (result: CMContractSettingResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contractSetting = response.setting;

                    if (this.contractSetting.isEntryACH)
                        this.showHidePaytype("bank");
                    else if (this.contractSetting.isEntryCC)
                        this.showHidePaytype("card");
                    else if (this.contractSetting.isEntryCheck)
                        this.showHidePaytype("check");
                    else if (this.contractSetting.isEntryCash)
                        this.showHidePaytype("cash");
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.getContractSetting", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getContractDetails() {
        await this._contractService.cmContractGet(this.encryptedUser, this.clpCompanyId, 0, 0, this.contractId).
            then(async (result: ContractResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contracts = response.contracts;
                    if (this.contracts?.length > 0) {
                        this.contract = this.contracts[0];
                        this.terminate = this.contract.contractTypeID == 8;

                        if (this.contract.deposit > 0) {
                            this.deposit = this.contract.deposit;
                            this.depositBase = this.contract.depositBase;
                            this.depositTax = this.contract.depositTax;
                            this.depositSurcharge = this.contract.depositSurcharge;

                            if (!this.contract.alreadyPaid) {
                                this.depositSummary = `Deposit Paid ${this.changeToCurrency(this.contract.deposit)}`;
                                this.depositSummaryFee = `${this.cFirstName} ${this.cLastName} paid a deposit of ${this.changeToCurrency(this.contract.deposit)} on ${this.getFormattedDate(this.contract.dtDeposit)}.`;
                            }
                            else {
                                let deposit = this.contract.depositBase + this.contract.depositTax
                                this.depositSummary = `Already Paid ${this.changeToCurrency(deposit)}`;
                                this.depositSummaryFee = `${this.cFirstName} ${this.cLastName} already paid ${this.changeToCurrency(deposit)} on ${this.getFormattedDate(this.contract.dtDeposit)}.`;
                            }
                        }

                        if (this.contract.statusID < eREF_CMContractStatus.In_Progress) {
                            this.cmContractStatus(eREF_CMContractStatus.In_Progress);
                        }
                        this.sessionId = localStorage.getItem("bcm_sessionid");

                        if (!this.sessionId || this.sessionId == '') {
                            this.UpdateSession(() => {
                                this.Log(`Contract has been opened.`);
                            });
                        }
                        else {
                            if (this.sessionId != this.contracts[0]?.sessionId) {
                                this.UpdateSession(() => {
                                    this.Log(`Contract has been opened.`);
                                });
                            }
                            else {
                                this.Log(`Contract has been opened.`);
                            }
                        }

                        this.getContractSetting();
                        this.siteId = this.contracts[0]?.siteID;
                        this.getClubDetails();
                        this.ProcessorContractPDFConvert_GET();
                        this.contracts?.forEach((item) => {
                            item.members?.forEach((mItem) => {
                                if (mItem.contactID == this.contactId) {
                                    this.getMemberFee(mItem.cMMemberID, true);
                                    this.memberId = mItem.cMMemberID;
                                    this.isPrimaryMem = mItem?.isPrimary
                                }
                            });
                        });
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContractDetails", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async UpdateSession(callback) {
        let session: CMSession = {
            cmContractID: this.contracts[0]?.cmContractID,
            sessionID: this.sessionId
        };
        await this._contractService.CMContract_Update_SessionId(this.encryptedUser, session).
            then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);

                    this.sessionId = response.messageString;
                    localStorage.setItem("bcm_sessionid", this.sessionId);
                    if (callback) {
                        callback();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract-client.UpdateSession", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async CheckSession(callback) {
        await this._contractService.CMContract_Get_SessionId(this.encryptedUser, this.contractId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);

                    if (response.messageString != this.sessionId) {
                        $('#sessionEndModal').modal('show');
                    }
                    else {
                        if (callback) {
                            callback();
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isPayment = false;
                this._globalService.error("cm-contract-client.GetSession", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    startFace2Face() {
        this.UpdateSession(() => {
            this.startF2F = true;
        })
    }

    hideSessionEndModal() {
        if (!this.is_client) {
            this.startF2F = false;
        }
        else {
            this.isUserVerified = false;
        }
        $('#sessionEndModal').modal('hide');
    }

    async getContractFee() {
        await this._contractService.cMContractFee_Get(this.encryptedUser, this.contractId).
            then(async (result: CMContractFeeListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.contractFees = response.contractFees;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContractFee", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getMemberFee(_memberId: number, isRedirect: boolean = false) {
        await this._contractService.getMemberFee(this.encryptedUser, this.contractId, _memberId).
            then(async (result: CMMemberFeeListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.memberFees = response.memberFees.filter(m => m.isRequirePM || m.isCollectNow);

                    let total = 0;

                    for (var i = 0; i < this.memberFees.length; i++) {
                        total += this.memberFees[i].feeBase;
                    }

                    if (total == 0) {
                        this.pay_download = false;
                    }
                    this.addTimeout(() => {
                        this.setProgressBar();
                    }, 100);
                    if (isRedirect) {
                        let isMember = false;
                        this.isPaySetup = false
                        if (this.memberFees.length > 0) {
                            for (var i = 0; i < this.memberFees.length; i++) {
                                if (this.memberFees[i].isDone)
                                    isMember = true;
                                else {
                                    isMember = false;
                                    if (this.memberFees[i].cmMemberFeeID != _memberId && (this.navigation?.isDetails && this.navigation?.isDetails)) {
                                        this.showDivItem(this.stepper, '#tdFee', 'p' + this.memberFees[i].cmMemberFeeID, this.memberFees[i], false, 2);
                                        return;
                                    }
                                }
                            }
                        }
                        if (isMember) {
                            this.isPaySetup = true
                            let disableReview = await this.disableReview()
                            if (!disableReview) {
                                this.showDivItem(this.stepper, '#tdReview', '19', null, false, 3);
                            }
                            else {
                                let msg = ''
                                if (!this.navigation?.isDetails) {

                                    msg += 'details';
                                    this.showDivItem(this.stepper, '#tdIsSOCDoc', '15', null, true, 0);
                                    return;
                                }
                                if (!this.isAllDocAccepted) {

                                    msg += ' & all documents';
                                    let cmconID = this.contractNavList[0]?.cMContractNavID;
                                    this.showDivItem(this.stepper, '#product', 'd' + cmconID, this.contractNavList[0], true, 1, 0)
                                }
                                this._notifyService.showError(`Please make sure ${msg} are setup to proceed further.`, "", 10000);
                            }
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getContractFee", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    getPaidFee(fee: CMMemberFee) {
        let f = fee?.feeBase + fee?.feeTax;

        return this.changeToCurrency(f);
    }

    getMemberById(_memberId: number) {
        if (this.memberFees.some(m => m.cmMemberFeeID == _memberId) == true) {
            this.memberFee = this.memberFees.filter(m => m.cmMemberFeeID == _memberId)[0];

            if (this.memberFee.isCollectNow && this.deposit > 0) {
                let total = 0;

                if (!this.contract.alreadyPaid) {
                    total = (this.memberFee.feeBase + this.memberFee.feeTax) - this.deposit;
                }
                else {
                    total = (this.memberFee.feeBase + this.memberFee.feeTax) - (this.depositBase + this.depositTax);
                }

                if (total < 0)
                    total = 0;
                this.memberFee.feeTotal = parseFloat(total.toFixed(2));
            }
        }
    }

    move(stepper: CdkStepper, index: number) {
        if (stepper) {

            stepper.selectedIndex = index;
        }
    }

    showDivItem(stepper: CdkStepper, divId: string, step: string, obj: any, navigation: boolean, index: number, position: number = 0, isLoad = true) {
        this.CheckSession(async () => {
            this.stepId = divId;
            switch (this.stepId) {
                case "#tdIsSOCDoc": this.currentActive = step; this.isProductDoc = false; this.scrollPageUp("#tdIsSOCDoc"); navigation ? this.Log('Navigation: <b>Details</b> clicked.') : false; break;
                case "#product": this.currentActive = step; this.isProductDoc = true; position == 0 ? this.isSignaturePad = true : this.isSignaturePad = false; this.showContractDocument(+step.replace('d', ''), isLoad); navigation ? this.Log(`Navigation: <b>${obj?.cmProductName}</b> clicked.`) : false; break;
                case "#tdFee": {
                    this.currentActive = step;
                    this.isProductDoc = false;
                    this.scrollPageUp("#divFee" + step);
                    this.memberFeeId = +step.replace('p', '');
                    this.cMPaymentTxn_Load();
                    this.getMemberById(this.memberFeeId);
                    this.CMPaymentItem_Get(this.memberFeeId);
                    navigation ? this.Log(`Navigation: <b>${obj?.cmFeeName}</b> clicked.`) : false;
                } break;
                case "#tdReview": this.currentActive = step; this.isProductDoc = false; this.scrollPageUp("#divReview"); this.addTimeout(() => { this.getPaymentReviews(); }, 200); navigation ? this.Log('Navigation: <b>Review</b> clicked.') : false; break;
                case "#tdPay": this.currentActive = step; this.isProductDoc = false; this.scrollPageUp("#divPay"); this.cMPaymentItem_Charge_Get(true); navigation ? this.Log('Navigation: <b>Pay</b> clicked.') : false; break;
                case "#tdDLUpload": this.currentActive = step; this.scrollPageUp("#divDLUpload"); navigation ? this.Log(`Navigation: <b>Driver's License</b> clicked.`) : false; break;
                default: break;
            }

            //this.stepId.includes("Sign") == true ? index = 1 : index = index;
            //this.getTransactionDetails(+step.replace('p', ''));
            if (stepper?.selectedIndex == index) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(this.stepId).length > 0 ? $(this.stepId).offset().top - 104 : 0
                }, 100);
            }
            else {
                if (stepper) {
                    stepper.selectedIndex = index;

                }
                this.addTimeout(() => {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(this.stepId).offset()?.top - 104
                    }, 100);
                }, 800);
            }
        });
    }

    showContractDocument(_docId, isLoad) {
        if (this.contractNavList.some(cn => cn.cMContractNavID == _docId) == true) {
            this.docId = _docId;
            let _productDoc = this.contractNavList.filter(cn => cn.cMContractNavID == _docId)[0];
            this.docTitle = _productDoc.cmProductName;
            this.productDoc = _productDoc.htmlText;
            this.contractList = this.contractNavList.filter(cn => cn.cMContractNavID == _docId)[0];
        }


        const iframeElement = this.iframeRef?.nativeElement;

        if (iframeElement) {

            if (this.userId == 0 && !isLoad) {
                this.addTimeout(() => {
                    const outerContainer = this.outerContainerDocRef.nativeElement;
                    this.scrollPage(iframeElement, outerContainer)
                }, 100)
            }
            else {
                this.renderer?.listen(iframeElement, 'load', () => {
                    this.addTimeout(() => {
                        const outerContainer = this.outerContainerDocRef.nativeElement;
                        this.scrollPage(iframeElement, outerContainer)
                    }, 100)
                });
            }
        }
    }

    matClick(e) {
        this.addTimeout(() => {
            switch (e.selectedIndex) {
                case 0: this.scrollPageUp('#tdIsSOCDoc'); this.showDivItem(this.stepper, '#tdIsSOCDoc', '15', null, false, 0); break;
                //case 1: this.showDivItem(this.stepper, '#divCPG',); break;
                //case 1: this.scrollPageUp('#divPS'); this.showDivItem(this.stepper, 1, '#divPS'); break;
                //case 2: !this.isSecondContract ? this.scrollPageUp('#dvSOCSignDoc') : this.scrollPageUp('#divPS');
                //    !this.isSecondContract ? this.showDivItem(this.stepper, 2, '#dvSOCSignDoc') : this.showDivItem(this.stepper, 2, '#divPS'); break;
                //case 3: this.scrollPageUp('#divCPG'); this.showDivItem(this.stepper, 3, '#divCPG'); break;
                default: break;
            }
        }, 300);
    }

    scrollPageDown() {
        $([document.documentElement, document.body]).animate({ scrollTop: $(document).height() }, 100);
    }

    scrollPageUp(divId) {
        $([document.documentElement, document.body]).animate({ scrollTop: $(divId).height() }, 100);
    }

    scrollPage(iframeElement: HTMLIFrameElement, outerContainer: HTMLElement) {
        if (iframeElement.contentWindow) {
            const iframeWindow = iframeElement.contentWindow;
            const iframeDocument = iframeElement.contentWindow.document;
            const contentHeight = iframeDocument.body.scrollHeight;

            iframeElement.style.height = contentHeight + 'px';
            iframeWindow.scrollTo(0, 0);
            iframeDocument.body.scrollTop = 0;
            iframeDocument.documentElement.scrollTop = 0;
            outerContainer.scrollTop = 0;
            outerContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    signatureFinalOnEnd() {
        if (this.signaturePadFinal?.isEmpty() == false) {
            this.initialFinalDisabled = true;
        }
    }

    signature2OnEnd() {
        if (this.signaturePad2?.isEmpty() == false) {
            this.initial2Disabled = true;
        }
    }

    initialFinalOnPress(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.productDocsGroup.controls.initialFinalSignature.value.length == 0) {
                this.signaturePadFinal.on();
                this.signaturePad2.on();
            }
            return;
        }
        this.signaturePadFinal.off();
        this.signaturePad2.off();
    }

    initialChange(e) {
        if (e.key == "Backspace" || e.key == "Delete") {
            if (this.productDocsGroup.controls.initial.value.length == 0) {
                this.signaturePadFinal.on();
                this.signaturePad2.on();
            }
            return;
        }
        this.signaturePadFinal.off();
        this.signaturePad2.off();
    }

    drawClearFinal(): boolean {
        this.signaturePadFinal.clear();
        this.signaturePadFinal.on();
        this.signaturePad2.on();
        if (this.signaturePadFinal?.isEmpty() == true) {
            this.initialFinalDisabled = false;
            this.productDocsGroup.patchValue({
                initialFinalSignature: ''
            });
        }

        return false;
    }


    drawClearInitial(): boolean {
        this.signaturePad2.clear();
        this.signaturePad2.on();
        if (this.signaturePad2?.isEmpty() == true) {
            this.initial2Disabled = false;
            this.productDocsGroup.patchValue({
                initial: ''
            });
        }

        return false;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    addMethodDetail(i) {
        let productObj = this.paymentForm.get("paymentMethods")['controls'][i].getRawValue();
        switch (+productObj?.paymentOption) {
            case 1:
                this.isShowCheckForm = true;
                this.isShowCCForm = false
                break;
            case 2:
                this.isShowCCForm = true;
                this.isShowCheckForm = false;
                break;
            case 3:
                this.isShowCheckForm = true;
                this.isShowCCForm = false
                break;
            case 4:
                this.isShowCheckForm = false;
                this.isShowCCForm = false
                break;
        }
    }

    changeToNumber(value: string): number {
        if (value != null && value != undefined) {
            if (value?.toString().includes('$'))
                return Number(value?.replace(/\$/g, '').replace(/\,/g, ''));
            else
                return Number(value);
        }
        else {
            return 0
        }
    }

    changeToNumber2(input: any): number {
        if (typeof input === 'number') return input;
        if (!input || typeof input !== 'string') return 0;

        const cleaned = input.replace(/[^0-9.]/g, '');
        return parseFloat(cleaned) || 0;
    }


    changeToCurrency(value: number): string {
        let final = '$0';

        if (value > 0) {
            final = `$${this.numberWithCommas((Math.round(value * 100) / 100).toFixed(2))}`;
        }
        return final;
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    onSaveCCInfo() {
    }

    onSaveACH() {
    }


    async productAcceptSign(cMContractNavID: number, docName: string, acceptAll: boolean = false, isSignature: boolean = false) {
        this.CheckSession(async () => {
            this.setValueForDocAccept();
            this.contractAcceptation.contractNavID = cMContractNavID;
            if (isSignature) {
                let penned = this.contractAcceptation.eSigFullImage != '' && this.contractAcceptation.eSigInitialsImage != '';
                let keyed = this.contractAcceptation.eFullName != '' && this.contractAcceptation.eInitials != '';

                if (!penned && !keyed) {
                    this._notifyService.showError("Please sign and initial the document.", "", 10000);

                    this.Log(`Documents: <b>Accept & Sign ${acceptAll ? 'All' : ''}</b> clicked (Signature) ${docName}. No Signature.`);
                    this.enableAll();
                    return;
                }
            }
            this.showSpinner = true
            await this._contractService.cmContractNavisAccepted(this.encryptedUser, this.contractAcceptation)
                .then(async (result: SimpleResponse) => {
                    if (result) {

                        if (result.messageBool) {
                            this.contractNavCopy = [];
                            this.Log(`Documents: <b>Accept & Sign ${acceptAll ? 'All' : ''}</b> Clicked${isSignature ? ' (Signature).' : '.'} ${docName} Accepted.`);

                            await this.processLoadDocCalls()

                            const orderMap = new Map(this.contractNavList.map(item => [item.cMContractNavID, item.sOrder]));

                            this.contractNavCopy.sort((a, b) => {
                                const orderA = orderMap.get(a.cMContractNavID) || 0;
                                const orderB = orderMap.get(b.cMContractNavID) || 0;
                                return orderA - orderB;
                            });
                            this.contractNavList = []
                            //this.contractNavList.push(...this.contractNavCopy)
                            this.contractNavList = UtilityService.clone(this.contractNavCopy);

                            if (this.contractNavList.filter(x => x.isAccepted == true && x.cMContractID == this.contractId).length == this.contractNavList.filter(x => x.cMContractID == this.contractId).length) {
                                this.cmMemberStatus(eREF_CMMemberStatus.eSigned, () => {
                                    this.updateIfSignedAll();
                                });
                            }

                            this.redirectNav(true);
                            this.drawClearFinal();
                            this.drawClearInitial();

                            if (!acceptAll) {
                                this._notifyService.showSuccess(docName + " was accepted successfully", "", 7000)
                            }
                        }
                        this.enableAll();
                        this.showSpinner = false;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.enableAll();
                    this.showSpinner = false
                    this._globalService.error("cm-contract-client.productAcceptSign", err.message, null);
                    this._utilityService.handleErrorResponse(err);
                });

            if (acceptAll) {
                this.productAcceptAll();
            }
        });
    }

    async downloadPreview() {
        this.isDownloaded = true;
        this.isForPreviewDownload = true;
        this.ProcessorContractPDFConvert_Add();

        this.Log(`<b>Download Preview</b> clicked.`);
    }

    async productAccept(cMContractNavID: number, docName: string) {
        //this.CheckSession(async () => {
        //this.setValueForDocAccept();
        this.contractAcceptation.contractId = this.contractId;
        this.contractAcceptation.contractNavID = cMContractNavID;
        this.showSpinner = true
        await this._contractService.cmContractNavisAccepted(this.encryptedUser, this.contractAcceptation)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    if (result.messageBool) {

                        this.Log(`Documents: <b>Accept & Sign</b> clicked. ${docName} Accepted.`);

                        let contractIdx = this.contractNavList.findIndex((item) => item?.cMContractNavID == cMContractNavID)

                        if (contractIdx != -1) {
                            this.contractNavList[contractIdx].isAccepted = true
                        }

                        if (this.contractNavList.filter(x => x.isAccepted == true && x.cMContractID == this.contractId).length == this.contractNavList.filter(x => x.cMContractID == this.contractId).length) {
                            this.cmMemberStatus(eREF_CMMemberStatus.eSigned, () => {
                                this.updateIfSignedAll();
                            });
                        }

                        this.redirectNav(true)
                        this.drawClearFinal();
                        this.drawClearInitial();
                        this._notifyService.showSuccess(docName + " was accepted successfully", "", 7000)

                    }
                    this.enableAll();
                    this.showSpinner = false
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.enableAll();
                this.showSpinner = false
                this._globalService.error("cm-contract-client.productAccept", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
        //});
    }

    updateIfSignedAll() {
        if (this.contract.members.length == 1) {
            if (this.contract.members[0].statusID == 5) {//eSigned
                this.cmContractStatus(eREF_CMContractStatus.Members_Signed);
                // Stamp dtSignedMembers as soon as the last member has signed,
                // independent of the payment flow (which previously was the only trigger).
                this.dtSignedMembers_Update();
            }
        }
        else if (this.contract.members.length > 1) {
            let everyoneSigned = true;

            //call it again just in case the other member signed after he began working on this contract.
            this._contractService.cmContractGet(this.encryptedUser, this.clpCompanyId, 0, 0, this.contractId).
                then(async (result: ContractResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        let _contracts = response.contracts;
                        if (_contracts?.length > 0) {
                            let _contract = _contracts[0];

                            _contract.members.forEach(m => {
                                if (m.statusID < 5) {//eSigned
                                    everyoneSigned = false;
                                }
                            });

                            if (everyoneSigned) {
                                this.cmContractStatus(eREF_CMContractStatus.Members_Signed);
                                // Stamp dtSignedMembers as soon as the last member has signed,
                                // independent of the payment flow (which previously was the only trigger).
                                this.dtSignedMembers_Update();
                            }
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("cm-contract.updateIfSignedAll", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    productAcceptAll() {
        this.showSpinner = true;
        if (this.contractNavList?.length > 0) {
            if (!this.contractNavList[0]?.isAccepted) {
                this.Log(`Documents: <b>Accept & Sign All</b> clicked. Accepted.`);

                if (Object.keys(this.contracts[0]?.members[0])?.length > 0) {
                    if (this.contracts[0]?.members[0]?.eSigFullImage == null && this.contracts[0]?.members[0]?.eSigInitialsImage == null && this.contracts[0]?.members[0].eInitials == null) {
                        this._notifyService.showError("Please sign the document.", "", 10000);
                        this.enableAll();
                        this.showSpinner = false;
                        return;
                    }
                }
                else {
                    this._notifyService.showError("Please sign the document.", "", 10000);
                    this.enableAll();
                    this.showSpinner = false;
                    return;
                }
            }

            this.contractNavList.forEach(async (item, index) => {
                this.contractAcceptation.contractId = this.contractId;
                this.contractAcceptation.contractNavID = item.cMContractNavID;

                await this._contractService.cmContractNavisAccepted(this.encryptedUser, this.contractAcceptation)
                    .then(async (result: SimpleResponse) => {
                        if (result) {
                            if (result.messageBool) {

                                this.Log(`<b>${item.cmProductName}</b> Accepted.`);
                                item.isAccepted = true;
                                //let contractIdx = this.contractNavList.findIndex((item) => item?.cMContractNavID == cMContractNavID)

                                //if (contractIdx != -1) {
                                //    this.contractNavList[contractIdx].isAccepted = true
                                //}

                                if (this.contractNavList.filter(x => x.isAccepted == true && x.cMContractID == this.contractId).length == this.contractNavList.filter(x => x.cMContractID == this.contractId).length) {
                                    this.cmMemberStatus(eREF_CMMemberStatus.eSigned, () => {
                                        this.updateIfSignedAll();
                                        this.redirectNav(true);
                                    });
                                }
                                this.drawClearFinal();
                                this.drawClearInitial();
                                this._notifyService.showSuccess(item.cmProductName + " was accepted successfully", "", 7000)
                            }
                            this.enableAll();
                            this.showSpinner = false
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.enableAll();
                        this.showSpinner = false
                        this._globalService.error("cm-contract-client.productAccept", err.message, null);
                        this._utilityService.handleErrorResponse(err);
                    });
            });
        }
        else
            this.showSpinner = false;
    }

    async checkIfAcceptAllProdSucc() {
        this.showSpinner = true;
        if (this.contractNavList?.length > 0) {
            for (let i = 0; i < this.contractNavList?.length; i++) {
                if (!this.contractNavList[i]?.isAccepted) {
                    let _contractNavList = this.contractNavList.slice();
                    let c = _contractNavList[i];

                    let cMContractNavID = c.cMContractNavID;
                    let docName = c.cmProductName;
                    this.contractAcceptation.contractId = this.contractId;
                    this.contractAcceptation.contractNavID = cMContractNavID;

                    await this._contractService.cmContractNavisAccepted(this.encryptedUser, this.contractAcceptation)
                        .then(async (result: SimpleResponse) => {
                            if (result) {
                                if (result.messageBool) {

                                    this.Log(`<b>${docName}</b> Accepted.`);
                                }

                                this.showSpinner = false;
                            }
                        })
                        .catch((err: HttpErrorResponse) => {
                            this.showSpinner = false;
                            this._globalService.error("cm-contract-client.productAccept", err.message, null);
                            this._utilityService.handleErrorResponse(err);
                        });
                    break;
                }
            }
        }
        else
            this.showSpinner = false;

    }

    async cmContractStatus(statusID: number) {
        await this._contractService.cmContractStatusUpdate(this.encryptedUser, this.contractId, this.clpCompanyId, !this.is_client ? this.user?.cLPUserID : 0, this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0, this.contactId, !this.is_client ? 1 : 0, statusID)
            .then(async (result: SimpleResponse) => {
                if (result && result?.messageInt != -1) {
                    this.contract.statusID = statusID;
                }
                else if (result) {
                    this._globalService.error("cm-contract-client.cmContractStatus", result?.messageString ?? "Contract status update was refused by the server.", null);
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract-cmContractStatus", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async cmMemberStatus(statusID: number, callback) {
        await this._contractService.cmMemberStatusUpdate(this.encryptedUser, this.contractId, !this.is_client ? this.user?.cLPUserID : 0, this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0, this.contactId, !this.is_client ? 1 : 0, this.memberId, statusID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    this.contract.members.find(m => m.cMMemberID == this.memberId).statusID = statusID;
                }

                if (callback) {
                    callback();
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract-cmMemberStatus", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }


    async processLoadDocCalls() {

        const apiCallObservables = this.contractNavList.map((item) =>
            this.loadDocs(item?.cMProductDocID, item?.cMContractNavID)
        );

        await forkJoin(apiCallObservables).toPromise();

    }

    setValueForDocAccept() {
        this.contractAcceptation.contractId = this.contractId;
        if (this.signaturePadFinal?.isEmpty() == false)
            this.contractAcceptation.eSigFullImage = this.signaturePadFinal.toDataURL('image/png', 0.9);
        else
            this.contractAcceptation.eSigFullImage = '';
        if (this.signaturePad2?.isEmpty() == false)
            this.contractAcceptation.eSigInitialsImage = this.signaturePad2.toDataURL('image/png', 0.9);
        else
            this.contractAcceptation.eSigInitialsImage = '';
        this.contractAcceptation.eFullName = this.productDocsGroup.controls["initialFinalSignature"].value;
        this.contractAcceptation.eInitials = this.productDocsGroup.controls["initial"].value;
    }

    showHidePaytype(paytype) {
        switch (paytype) {
            case 'bank': this.payType = "bank";
                break;
            case 'card': this.payType = "card";
                break;
            case 'cash': this.payType = "cash";
                break;
            case 'check': this.payType = "check";
                break;
            default:
        }
    }

    showModal() {
        //if (_transactionId == -2) {
        $('#PaymentMethodModal').modal('show');
        this.ccForm = this.prepareCCForm();
        this.bankForm = this.prepareBankForm();
        this.ccForm.reset();
        this.bankForm.reset();
        this.payType = 'card';

        this.ccForm.patchValue({
            name: `${this.contactDetails?.firstName} ${this.contactDetails?.lastName}`,
            address: this.contactDetails?.add1,
            zipcode: this.contactDetails?.zip,
            phone: this.contactDetails?.mobile,
            email: this.contactDetails?.email,
            city: this.contactDetails?.city,
            state: this.contactDetails?.state,
            country: this.contactDetails?.country ? this.contactDetails?.country != 'US' ? 'US' : this.contactDetails?.country : 'US',
            isAllowOtherMem: false
        });

        this.bankForm.patchValue({
            accountName: `${this.contactDetails?.firstName} ${this.contactDetails?.lastName}`,
            accountAddress: this.contactDetails?.add1,
            accountZip: this.contactDetails?.zip,
            accountPhone: this.contactDetails?.mobile,
            accountEmail: this.contactDetails?.email,
            accountCity: this.contactDetails?.city,
            accountState: this.contactDetails?.state,
            accountCountry: this.contactDetails?.country ? this.contactDetails?.country != 'US' ? 'US' : this.contactDetails?.country : 'US',
            accountType: 'personal'
        });
        //}
    }

    hideModal() {
        this.Log('Add Payment Method dialog closed.');
        $('#PaymentMethodModal').modal('hide');
    }

    async unixTimestamp() {
        await this._contractService.unixTimestamp(this.contractId, this.clpCompanyId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    this.unixDate = result?.messageInt
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.unixTimestamp", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    //#region payment

    private prepareCCForm(): FormGroup {
        return this.fb.group({
            creditCard: [{ value: '' }, [CreditCardValidators.validateCCNumber]],
            name: [{ value: '' }, [Validators.required, Validators.pattern(/^[a-zA-Z\s'-]+$/)]],
            exp: [{ value: '' }, [Validators.required]],
            cvc: [{ value: '' }, [Validators.required, Validators.minLength(3), Validators.pattern('^[0-9]*$')]],
            address: [{ value: '' }, [Validators.required]],
            zipcode: [{ value: '' }, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]{3,7}$/)]],
            phone: [{ value: '' }, [Validators.required]],
            email: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            city: [{ value: '' }, [Validators.required]],
            state: [{ value: '' }, [Validators.required]],
            country: [{ value: 'US' }, [Validators.required]],
            isAllowOtherMem: [{ value: false }]
            //promoCode: [{ value: '' }]
        });
    }

    private prepareBankForm(): FormGroup {
        return this.fb.group({
            cMPaymentItemID: [0],
            routingNumber: [{ value: '' }, [Validators.required]],
            accountNumber: [{ value: '' }, [Validators.required]],
            accountType: ['personal'],
            institution: ['', [Validators.required]],
            businessName: [''],
            accountName: [{ value: '' }, [Validators.required]],
            accountPhone: [{ value: '' }, [Validators.required]],
            accountEmail: [{ value: '' }, [Validators.required, Validators.pattern(/^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/)]],
            accountAddress: [{ value: '' }, [Validators.required]],
            accountCity: [{ value: '' }, [Validators.required]],
            accountZip: [{ value: '' }, [Validators.required, Validators.pattern(/^[a-zA-Z0-9\s]{5,7}$/)]],
            accountState: [''],
            accountCountry: ['US'],
        });
    }



    verifyExp(event: any) {
        if (event.target.value.length == 5) {
            let exp = event.target.value;

            let strmonth = exp.substring(0, 2);
            let year = '20' + exp.substring(3, 5);
            let month = +strmonth - 1;

            if (strmonth === '00' || month > 11) {
                this.creditcardform.exp.setErrors({ 'incorrect': true });
                return;
            }

            var d = new Date(+year, month, 1);
            var n = new Date();

            if (n > d)
                this.creditcardform.exp.setErrors({ 'incorrect': true });
        }
    }

    changeUpperCase(e) {
        if (this.creditcardform.zipcode.value) {
            let _zip = this.creditcardform.zipcode.value;
            this.creditcardform.zipcode.setValue(_zip.toUpperCase())
        }
    }

    //#endregion

    async onVerify() {
        this.isPayment = true
        this.CheckSession(async () => {
            switch (this.payType) {
                case 'card': {
                    let cc: CC = {
                        contactId: this.contactId,
                        cmMemberId: this.memberId,
                        contractId: this.contractId,
                        vCustomerId: this.vendorCustomerId,
                        vCustomerId2: this.vendorCustomerId2,
                        vCustomerIdPrimary: this.vCustomerIdPrimary,
                        memberFeeId: this.memberFeeId,
                        total: 0,
                        creditCard: this.creditcardform.creditCard.value,
                        name: this.creditcardform.name.value,
                        exp: this.creditcardform.exp.value,
                        cvc: this.creditcardform.cvc.value,
                        address: this.creditcardform.address.value,
                        zipcode: this.creditcardform.zipcode.value,
                        phone: this.creditcardform.phone.value,
                        email: this.creditcardform.email.value,
                        city: this.creditcardform.city.value,
                        state: this.creditcardform.state.value,
                        country: this.creditcardform.country.value,
                        txnId: 0,
                        isAllowOtherMem: (this.creditcardform.isAllowOtherMem.value) ? this.creditcardform.isAllowOtherMem.value : false,
                    }

                    if (cc.isAllowOtherMem) {
                        this.Log('<b>Allow this card to be used by other members</b> enabled.');
                    }

                    //this.holdPayState()
                    await this.verifyCreditCard(cc);
                    this.cMPaymentTxn_Load();
                }
                    break;
                case 'bank': {
                    let bank: Bank = {
                        contactId: this.contactId,
                        cmMemberId: this.memberId,
                        contractId: this.contractId,
                        memberFeeId: this.memberFeeId,
                        vCustomerId: this.vendorCustomerId,
                        vCustomerId2: this.vendorCustomerId2,
                        total: 0,
                        routingNumber: this.bankform.routingNumber.value,
                        accountNumber: this.bankform.accountNumber.value,
                        accountType: this.bankform.accountType.value,
                        institution: this.bankform.institution.value,
                        businessName: this.bankform.businessName.value,
                        accountName: this.bankform.accountName.value,
                        accountPhone: this.bankform.accountPhone.value,
                        accountEmail: this.bankform.accountEmail.value,
                        accountAddress: this.bankform.accountAddress.value,
                        accountCity: this.bankform.accountCity.value,
                        accountZip: this.bankform.accountZip.value,
                        accountState: this.bankform.accountState.value,
                        accountCountry: this.bankform.accountCountry.value,
                        txnId: 0
                    }

                    this.verifyBankAccount(bank);
                }
                    break;
                case 'cash': {
                    let cash: CheckCash = {
                        contactId: this.contactId,
                        cmMemberId: this.memberId,
                        contractId: this.contractId,
                        vCustomerId: this.vendorCustomerId,
                        vCustomerId2: this.vendorCustomerId2,
                        memberFeeId: this.memberFeeId,
                        isCash: true,
                        total: 0
                    }

                    this.verifyCheckCash(cash);
                }
                    break;
                case 'check': {
                    let check: CheckCash = {
                        contactId: this.contactId,
                        cmMemberId: this.memberId,
                        contractId: this.contractId,
                        vCustomerId: this.vendorCustomerId,
                        vCustomerId2: this.vendorCustomerId2,
                        memberFeeId: this.memberFeeId,
                        isCash: false,
                        total: 0
                    }

                    this.verifyCheckCash(check);
                }
                    break;
            }
        });
    }

    holdPayState() {
        this.paymentState = []
        this.paymentMethods.controls.forEach((item, index) => {
            let _paymentSource = {
                cMPaymentItemID: item?.getRawValue()?.cMPaymentItemID,
                cMContractFeeID: item?.getRawValue()?.cMContractFeeID,
                cMPaymentTxnID: item?.getRawValue()?.cMPaymentTxnID,
                feeAmount: item?.getRawValue()?.feeAmount,
                paymentType: item?.getRawValue()?.paymentType,
                isPaymentDone: item?.getRawValue()?.isPaymentDone,
            }

            this.paymentState.push(_paymentSource)
        });

    }


    disableOnVerify() {
        switch (this.payType) {
            case 'bank': {
                if (!this.bankform.routingNumber.value ||
                    !this.bankform.accountNumber.value ||
                    !this.bankform.accountName.value ||
                    !this.bankform.accountPhone.value ||
                    !this.bankform.accountEmail.value ||
                    !this.bankform.accountAddress.value ||
                    !this.bankform.accountCity.value ||
                    !this.bankform.institution.value ||
                    !this.bankform.accountZip.value)
                    return true;
                else {
                    if ((this.bankform.routingNumber.errors && (this.bankform.routingNumber.touched || this.bankform.routingNumber.dirty)) ||
                        (this.bankform.accountNumber.errors && (this.bankform.accountNumber.touched || this.bankform.accountNumber.dirty)) ||
                        (this.bankform.accountName.errors && (this.bankform.accountName.touched || this.bankform.accountName.dirty)) ||
                        (this.bankform.accountPhone.errors && (this.bankform.accountPhone.touched || this.bankform.accountPhone.dirty)) ||
                        (this.bankform.accountEmail.errors && (this.bankform.accountEmail.touched || this.bankform.accountEmail.dirty)) ||
                        (this.bankform.accountAddress.errors && (this.bankform.accountAddress.touched || this.bankform.accountAddress.dirty)) ||
                        (this.bankform.accountCity.errors && (this.bankform.accountCity.touched || this.bankform.accountCity.dirty)) ||
                        (this.bankform.accountZip.errors && (this.bankform.accountZip.touched || this.bankform.accountZip.dirty)) ||
                        (this.bankform.institution.errors && (this.bankform.institution.touched || this.bankform.institution.dirty))
                    )
                        return true;
                }
            }
                break;
            case 'card': {
                if (!this.creditcardform.creditCard.value ||
                    !this.creditcardform.name.value ||
                    !this.creditcardform.exp.value ||
                    !this.creditcardform.cvc.value ||
                    !this.creditcardform.address.value ||
                    !this.creditcardform.zipcode.value ||
                    !this.creditcardform.phone.value ||
                    !this.creditcardform.email.value ||
                    !this.creditcardform.city.value || !this.creditcardform.state.value || !this.creditcardform.country.value)
                    return true;
                else {
                    if ((this.creditcardform.creditCard.errors && (this.creditcardform.creditCard.touched || this.creditcardform.creditCard.dirty)) ||
                        (this.creditcardform.name.errors && (this.creditcardform.name.touched || this.creditcardform.name.dirty)) ||
                        (this.creditcardform.exp.errors && (this.creditcardform.exp.touched || this.creditcardform.exp.dirty)) ||
                        (this.creditcardform.cvc.errors && (this.creditcardform.cvc.touched || this.creditcardform.cvc.dirty)) ||
                        (this.creditcardform.address.errors && (this.creditcardform.address.touched || this.creditcardform.address.dirty)) ||
                        (this.creditcardform.zipcode.errors && (this.creditcardform.zipcode.touched || this.creditcardform.zipcode.dirty)) ||
                        (this.creditcardform.phone.errors && (this.creditcardform.phone.touched || this.creditcardform.phone.dirty)) ||
                        (this.creditcardform.email.errors && (this.creditcardform.email.touched || this.creditcardform.email.dirty)) ||
                        (this.creditcardform.city.errors && (this.creditcardform.city.touched || this.creditcardform.city.dirty)) ||
                        (this.creditcardform.state.errors && (this.creditcardform.state.touched || this.creditcardform.state.dirty)) ||
                        (this.creditcardform.country.errors && (this.creditcardform.country.touched || this.creditcardform.country.dirty))
                    )
                        return true;
                }
            }
                break;
            default:
                return false;
        }
    }

    async verifyCreditCard(cc: CC) {
        this.isPayment = true;
        await this._paymentService.addCreditCard(this.encryptedUser, cc)
            .then(async (result: SimpleResponse) => {
                this.isPayment = false;
                if (result.messageBool) {
                    //this.unixDate = result?.messageInt
                    this.lastPaymentId = result?.messageString
                    this.lastPaymentId2 = result?.messageString2
                    this._notifyService.showSuccess("Your credit card was added successfully.", "Success", 7000)
                    cc.txnId = result.messageInt;

                    if (cc.txnId > 0) {
                        //refresh cc details everywhere.
                        this.cMPaymentTxn_Load();
                        this.cMPaymentItem_Charge_Get(true);
                    }

                    this.Log(`${result?.messageString2} added.`);
                    this.hideModal();
                    this.hideEditCardModal();
                }
                else if (result.messageString2) {
                    this._notifyService.showError(result.messageString2, "Failed", 10000);
                    this.Log(`Verifying Credit Card failed: ${result?.messageString2}.`);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isPayment = false
                this.hideModal();
                this.hideEditCardModal();
                this._globalService.error("cm-contract-client.addCreditCard", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    addNewEntry() {
        if (this.memberFee?.isPaymentSplitable) {
            let isControlExist = false
            this.paymentMethods.controls.forEach((ctrl) => {
                if (ctrl?.getRawValue()?.cMPaymentTxnID == -1) {
                    isControlExist = true
                }
            })

            if (!isControlExist) {
                let _paymentSource = {
                    cMPaymentItemID: 0,
                    cMContractFeeID: 0,
                    cMPaymentTxnID: 0,
                    feeAmount: this.paymentMethods?.length == 0 ? this.changeToCurrency(this.memberFee?.feeTotal) : "$0.00",
                    paymentType: 0
                }

                this.paymentState.push(_paymentSource)
            }
        }

    }

    async verifyBankAccount(bank: Bank) {
        await this._paymentService.addBankAccount(this.encryptedUser, bank)
            .then(async (result: SimpleResponse) => {
                this.isPayment = false;
                if (result) {
                    if (result.messageBool) {
                        //this.unixDate = result?.messageInt
                        this.lastPaymentId = result?.messageString
                        this.lastPaymentId2 = result?.messageString2
                        this._notifyService.showSuccess("Your bank account was added successfully.", "Success", 7000)
                        bank.txnId = result.messageInt;

                        if (bank.txnId > 0) {
                            //refresh cc details everywhere.
                            this.cMPaymentTxn_Load();
                            this.cMPaymentItem_Charge_Get(true);
                        }

                        this.Log(`${result?.messageString2} added.`);
                        this.hideModal();
                        this.hideEditCardModal();
                        this.hideEditBankModal()
                    }
                    else if (result.messageString2) {
                        this._notifyService.showError(result.messageString2, "Failed", 10000);
                        this.Log(`Verifying Credit Card failed: ${result?.messageString2}.`);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isPayment = false;
                this.hideModal();
                this._globalService.error("cm-contract-client.addBankAccount", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async verifyCheckCash(cc: CheckCash) {

        if (this.payType == 'cash') {
            let isCashPayExists = this.paymentTrxs.find(item => item?.paymentType == 4)
            if (isCashPayExists) {
                this.hideModal();
                this.isPayment = false;
                return;
            }
        }

        if (this.payType == 'check') {
            let isCheckPayExists = this.paymentTrxs.find(item => item?.paymentType == 3)
            if (isCheckPayExists) {
                this.hideModal();
                this.isPayment = false;
                return;
            }
        }
        this.isPayment = true;
        await this._paymentService.addCheckCash(this.encryptedUser, cc)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    this.isPayment = false;
                    //this.unixDate = result?.messageInt
                    if (result.messageBool) {

                        //await this.addNewEntry()
                        this.cMPaymentTxn_Load();
                        let p = cc.isCash ? 'Cash' : 'Check';
                        this._notifyService.showSuccess(`A ${p} payment was added.`, "Payment", 7000)
                        this.hideModal();
                    }
                    else {
                        this._notifyService.showError(`An error occurred adding a payment. Our team has been notified.`, "Payment", 10000);
                        this.hideModal();
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isPayment = false
                this.hideModal();
                this._globalService.error("cm-contract-client.addCheckCash", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getProgressBar(stepComplete: number) {
        this.addTimeout(() => {
            if (this.progressPreFetch <= 100)
                this.progressPreFetch += stepComplete;
            else
                this.progressPreFetch = 100;
        }, 100);
    }


    resizeCanvas() {
        var canvas = document.getElementsByTagName("canvas")[0];
        var canvas1 = document.getElementsByTagName("canvas")[1];
        if (canvas) {
            var card = document.getElementsByClassName("signature-pad");
            var outer = document.getElementsByClassName("signature-pad");
            canvas.width = outer[0].clientWidth;
            canvas.height = 200;
        }
        if (canvas1) {
            var outer1 = document.getElementsByClassName("signature-pad1");
            canvas1.width = outer1[0].clientWidth;
            canvas1.height = 200;
        }
    }

    async cMPaymentTxn_Load() {
        await this._paymentService.cMPaymentTxn_LoadByFee(this.encryptedUser, this.clpCompanyId, this.contractId, this.memberId, this.memberFeeId)
            .then(async (result: CMPaymentTxnResponse) => {
                if (result) {
                    this.paymentTrxsFinal = [];
                    this.paymentMethods.clear();
                    this.paymentTrxs = result?.cmPaymentTxnList;
                    this.allCardPayments = result?.totalPaymentByCard;
                    this.allCardPayments.forEach((item) => item.isCharged = false)

                    await this.setPaySourceDD();
                    if (!this.memberFee?.isPaymentSplitable && this.lastPaymentId != '') {
                        let lastCardObj = this.paymentTrxs.filter((item) => item?.vPaymentMethodID == this.lastPaymentId)[0]
                        this.paymentState[0].cMPaymentTxnID = lastCardObj?.cMPaymentTxnID
                    }

                    if (this.paymentState?.length > 0) {
                        this.paymentState.forEach((item) => {
                            let payObject = this.paymentTrxs.filter((pay) => pay?.cMPaymentTxnID == item?.cMPaymentTxnID)[0]

                            let lastPayObject = <CMPaymentTxn>{}
                            switch (this.payType) {
                                case 'card':
                                    lastPayObject = this.paymentTrxs.filter((item) => item?.vPaymentMethodID == this.lastPaymentId)[0]
                                    break;
                                case 'bank':
                                    lastPayObject = this.paymentTrxs.filter((item) => item?.vPaymentMethodID == this.lastPaymentId)[0]
                                    break;
                                case 'cash':
                                    lastPayObject = this.paymentTrxs.filter((item) => item?.paymentType == 4)[0]
                                    break;
                                case 'check':
                                    lastPayObject = this.paymentTrxs.filter((item) => item?.paymentType == 3)[0]
                                    break;
                            }

                            if (payObject?.cMPaymentTxnID == item?.cMPaymentTxnID) {
                                let _paymentSource = this.fb.group({
                                    cMPaymentItemID: item.cMPaymentItemID,
                                    cMContractFeeID: item?.cMContractFeeID,
                                    cMPaymentTxnID: [{ value: this.checkIfLastPayExist(item.cMPaymentTxnID), disabled: item?.isPaymentDone }],
                                    feeAmount: [{
                                        value: item.feeAmount, disabled: item?.isPaymentDone
                                    }],
                                    paymentType: item?.paymentType,
                                    isPaymentDone: item?.isPaymentDone
                                });
                                this.paymentMethods.push(_paymentSource);
                            }
                            else {
                                let _paymentSource = this.fb.group({
                                    cMPaymentItemID: item?.cMPaymentItemID,
                                    cMContractFeeID: this.memberFeeId,
                                    cMPaymentTxnID: this.checkIfLastPayExist(lastPayObject?.cMPaymentTxnID),
                                    feeAmount: item?.feeAmount,
                                    paymentType: lastPayObject?.paymentType,
                                    isPaymentDone: item?.isPaymentDone
                                });
                                this.paymentMethods.push(_paymentSource);
                            }
                        })
                    }

                    this.holdPayState()

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.cMPaymentTxn_Load", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    checkIfLastPayExist(cMPaymentTxnID) {
        if (this.paySourceDD?.length > 0) {
            let isExists = this.paySourceDD?.find((item) => item?.cMPaymentTxnID == cMPaymentTxnID);
            if (isExists) {
                if (this.memberFees?.some((item) => item?.feeBase == 0 && item.cmMemberFeeID == this.memberFeeId) == true) {
                    let allowOtherMem = this.paySourceDD?.filter((item) => item?.isAllowOtherMem == true)[0];
                    return allowOtherMem?.cMPaymentTxnID > 0 ? allowOtherMem?.cMPaymentTxnID : cMPaymentTxnID;
                }
                else
                    return cMPaymentTxnID;
            }
            else {
                if (this.memberFees?.some((item) => item?.feeBase == 0 && item.cmMemberFeeID == this.memberFeeId) == true) {
                    let allowOtherMem = this.paySourceDD?.filter((item) => item?.isAllowOtherMem == true)[0];
                    return allowOtherMem?.cMPaymentTxnID > 0 ? allowOtherMem?.cMPaymentTxnID : -1;
                }
                else
                    return -1;
            }
        }
        return -1;
    }

    setPaySourceDD() {
        this.paySourceDD = []

        const trnxSet = new Set<number>();

        let isAllowOtherMemCard = true;
        this.paymentTrxs.forEach(obj => {
            if (!this.memberFee?.isCollectNow) {
                if (obj.paymentType <= 2) {
                    if (!trnxSet.has(obj.cMPaymentTxnID)) {
                        trnxSet.add(obj.cMPaymentTxnID);
                        if (obj?.isAllowOtherMem) {
                            isAllowOtherMemCard = this.showAllowOtherMemCard(obj);
                        }
                        if (isAllowOtherMemCard) {
                            this.paySourceDD.push(obj);
                        }
                        else {
                            if (!obj?.isAllowOtherMem) {
                                this.paySourceDD.push(obj);
                            }
                        }

                    }
                }
            }
            else {
                if (!trnxSet.has(obj.cMPaymentTxnID)) {
                    trnxSet.add(obj.cMPaymentTxnID);
                    if (obj?.isAllowOtherMem) {
                        isAllowOtherMemCard = this.showAllowOtherMemCard(obj);
                    }
                    if (isAllowOtherMemCard) {
                        this.paySourceDD.push(obj);
                    }
                    else {
                        if (!obj?.isAllowOtherMem) {
                            this.paySourceDD.push(obj);
                        }
                    }
                }
            }
        });

    }

    showAllowOtherMemCard(payObj) {
        if (payObj?.cMMemberID == this.memberId) {
            return true;
        }
        else {
            if (this.memberFees?.some((item) => item?.feeBase == 0 && item.cmMemberFeeID == this.memberFeeId) == true) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    getTransactionDetails(memberFeeId: number) {
        if (this.paymentTrxs && this.paymentTrxs.length > 0) {
            if (this.paymentTrxs.some(x => x.memberFeeId == memberFeeId) == true) {
                this.totalBeingPaid = 0;
                this.paymentMethods.controls.forEach((item, index) => {
                    this.totalBeingPaid += +item.getRawValue().feeAmount;
                });
                this.displayBeingPaid = this.changeToCurrency(this.totalBeingPaid);
            }
        }
    }

    async CMPaymentItem_Get(memberFeeId: number) {
        await this._paymentService.CMPaymentItem_Get(this.encryptedUser, memberFeeId)
            .then(async (result: CMPaymentItem[]) => {
                if (result) {
                    this.cmPaymentItems = [];
                    await this.paymentMethods.clear();
                    this.cmPaymentItems = UtilityService.clone(result);

                    this.setPaySourceDD();
                    if (this.cmPaymentItems.length > 0) {
                        this.paymentMethods.clear();
                        this.cmPaymentItems.forEach((item, index) => {
                            if (item.cMMemberFeeID == memberFeeId) {
                                let payTrnx = this.paymentTrxs?.filter((pay) => pay?.cMPaymentTxnID == item?.cMPaymentTxnID)[0]
                                let _paymentSource = this.fb.group({
                                    cMPaymentItemID: item.cMPaymentItemID,
                                    cMContractFeeID: item.cMContractFeeID,
                                    cMPaymentTxnID: [{ value: this.checkIfLastPayExist(item.cMPaymentTxnID), disabled: item?.isPaymentDone }],
                                    feeAmount: [{
                                        value: this.changeToCurrency(item.feeTotal), disabled: item?.isPaymentDone
                                    }],
                                    paymentType: payTrnx?.paymentType,
                                    isPaymentDone: item?.isPaymentDone
                                });
                                this.paymentMethods.push(_paymentSource);
                                this.lastcMPaymentTxnID = item.cMPaymentTxnID;
                            }
                        });
                    }
                    else {
                        this.paymentMethods.clear();
                        let _paymentSource = this.fb.group({
                            cMPaymentItemID: 0,
                            cMContractFeeID: this.memberFeeId,
                            cMPaymentTxnID: this.checkIfLastPayExist(this.lastcMPaymentTxnID),
                            feeAmount: this.changeToCurrency(this.memberFee?.feeTotal),
                            paymentType: this.paySourceDD[0]?.paymentType ? this.paySourceDD[0]?.paymentType : 0,
                            isPaymentDone: false
                        });
                        this.paymentMethods.push(_paymentSource);
                    }


                    this.holdPayState();
                    this.onChangeAmount(false);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.CMPaymentItem_Get", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });

    }

    addPayment() {
        if (this.paymentForm.controls['cMPaymentTxnID'].value == "-1") {
            this._notifyService.showError("Please select a payment method.", "", 10000);
        }
        else {
            this.transactionId = +this.paymentForm.controls['cMPaymentTxnID'].value;
            if (!this.paymentTrxsFinal)
                this.paymentTrxsFinal = [];
            if (this.paymentTrxsFinal.some(x => x.cMPaymentTxnID == this.transactionId) == true) {
                this._notifyService.showError("this payment method was already added", "", 10000);
            }
            else {
                let payTxn = this.paymentTrxs.filter(y => y.cMPaymentTxnID == this.transactionId)[0];
                this.paymentTrxsFinal.push(payTxn);
            }
        }
    }


    paymentChange(amunt: number, txnId) {
        this.paymentTrxsFinal.forEach((item) => {
            if (item.cMPaymentTxnID == txnId) {
                item.total = amunt;
            }
        });
        this.totalBeingPaid = 0;
        this.paymentTrxsFinal.forEach((item) => {
            this.totalBeingPaid += +item.total;
            item.displayAmount = this.changeToCurrency(+item.total);
        });
        this.displayBeingPaid = this.changeToCurrency(this.totalBeingPaid);
    }

    hideMemberPaymentAll(fee: CMMemberFee) {
        if (fee?.feeTotal == 0 && fee?.isCollectNow) {
            return true;
        }
        else {
            let isAnyPaySaved = false;
            for (let i = 0; i < this.memberFees?.length; i++) {
                if (this.memberFees[i]?.isDone) {
                    isAnyPaySaved = true
                    break;
                }
            }

            if (this.paySourceDD.length == 1 && this.cmPaymentItems?.length == 0 && this.paymentMethods?.length == 1 && this.memberFees.length > 1 && !isAnyPaySaved) {
                if (this.paySourceDD[0].paymentType == 1) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return true;
            }
        }
    }

    async saveMemberPayment(fee: CMMemberFee) {
        let feeName = fee?.cmFeeName;
        let cmMemberFeeID = fee?.cmMemberFeeID;

        this.CheckSession(async () => {
            await this.navigationUpdate(eCMNavigation_Update_Type.isReview, false);
            this.totalBeingPaid = 0;

            for (let i = 0; i < this.paymentMethods?.length; i++) {
                const control = this.paymentMethods.at(i);
                const cMPaymentTxnID = control.get('cMPaymentTxnID').value;
                const feeAmount = control.get('feeAmount').value;

                if (cMPaymentTxnID == -1 || cMPaymentTxnID == 0) {
                    this._notifyService.showError("Please choose a valid Payment Source.", "", 10000);
                    this.Log(`Payments: A valid payment source was not chosen when Saving a Fee.`);
                    this.enableAll();
                    return;
                }
                else {
                    this.totalBeingPaid += this.changeToNumber(feeAmount);
                }
            }

            this.totalBeingPaid = Number(this.totalBeingPaid.toFixed(2));
            //this.displayBeingPaid = this.changeToCurrency(this.totalBeingPaid);
            if (this.totalBeingPaid < (+this.memberFee?.feeTotal) && this.contract.deposit <= 0) {
                if (this.contract.deposit <= 0) {
                    this._notifyService.showError("Your payment amount is less than " + feeName + "'s amount", "", 10000);
                    this.Log(`Payments: Payment amount is less than ${feeName}'s amount (total being paid: ${this.totalBeingPaid}, fee total: ${this.memberFee?.feeTotal}).`);
                    return;
                }
            }
            else if (this.totalBeingPaid > (+this.memberFee?.feeTotal)) {
                if (this.contract.deposit <= 0) {
                    this._notifyService.showError("Your payment amount exceeded " + feeName + "'s amount", "", 10000);
                    this.Log(`Payments: Payment amount exceeded ${feeName}'s amount (total being paid: ${this.totalBeingPaid}, fee total: ${this.memberFee?.feeTotal}).`);
                    return;
                }
            }

            let feeId = this.contractFees?.filter(c => c.cMFeeName == feeName)[0]?.cMContractFeeID;
            await this.mergeMultipleCashCheckPays(3)
            await this.mergeMultipleCashCheckPays(4)
            this.paymentMethods.controls.forEach(async (item, index) => {
                let txnId = item.getRawValue().cMPaymentTxnID;

                let amount_to_charge = this.changeToNumber(item.getRawValue().feeAmount);

                this.cmPaymentItem.cMContractFeeID = feeId;
                this.cmPaymentItem.cMMemberFeeID = cmMemberFeeID;
                this.cmPaymentItem.cMPaymentItemID = item.getRawValue().cMPaymentItemID;
                this.cmPaymentItem.cMPaymentTxnID = txnId;
                this.cmPaymentItem.feeTotal = parseFloat(amount_to_charge.toFixed(2));

                this.cmPaymentItem.isPaymentDone = false;
                this.showSpinner = true
                await this._paymentService.CMPaymentItem_Create(this.encryptedUser, this.cmPaymentItem)
                    .then(async (result: SimpleResponse) => {
                        this.enableAll();
                        this.showSpinner = false
                        if (result?.statusCode == 1) {
                            if (this.paymentMethods.controls.length - 1 == index) {
                                this._notifyService.showSuccess(`The ${feeName} payment was saved successfully`, "", 7000)

                                let txn: CMPaymentTxn = this.paySourceDD.find(s => s.cMPaymentTxnID == txnId);
                                let details = '';

                                if (txn) {
                                    details = `Details: ${txn.paymentMethodSummary}. Allow other members to use: ${txn.isAllowOtherMem}`;
                                }

                                this.Log(`Payments: <b>Save</b> clicked. ${feeName} ${item.getRawValue().feeAmount} payment method was saved. ${details}`);
                                this.CMPaymentItem_Get(cmMemberFeeID);
                                this.getMemberFee(this.memberId, true);
                            }
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.showSpinner = false
                        this.enableAll();
                        this._globalService.error("cm-contract-client.saveMemberPayment", err.message, null);
                        this._utilityService.handleErrorResponse(err);
                        this.Log(`Payments: ${feeName} payment for ${item.getRawValue().feeAmount} was not saved ${err.message}.`);
                    });
            });
        });
    }

    async saveNoPayment(fee: CMMemberFee) {
        let feeName = fee?.cmFeeName;
        let cmMemberFeeID = fee?.cmMemberFeeID;

        this.CheckSession(async () => {
            await this.navigationUpdate(eCMNavigation_Update_Type.isReview, false);

            let feeId = this.contractFees?.filter(c => c.cMFeeName == feeName)[0]?.cMContractFeeID;

            let txn: CMPaymentTxnNoFee = {
                cMContractID: this.contract.cmContractID,
                cMMemberID: fee.memberID,
                memberFeeId: fee.cmMemberFeeID,
                contractFeeId: feeId,
                vCustomerID: this.vendorCustomerId,
                vCustomerID2: this.vendorCustomerId2,
                paymentType: 0,
                paymentMethodSummary: "No Fee Transaction",
                total: 0
            }

            await this._paymentService.CMPaymentTxn_CreateNoFee(this.encryptedUser, txn)
                .then(async (result: SimpleResponse) => {
                    if (result?.statusCode == 1) {
                        //this.cMPaymentTxn_Load();

                        this._notifyService.showSuccess(`The ${feeName} was saved successfully`, "", 7000);

                        this.Log(`Payments: <b>Save</b> clicked. ${feeName} $0 payment method was saved.`);
                        this.CMPaymentItem_Get(cmMemberFeeID);
                        await this.getMemberFee(this.memberId, true);
                        this.enableAll();
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.enableAll();
                    this.showSpinner = false
                    this._globalService.error("cm-contract-client.CMPaymentTxn_CreateNoFee", err.message, null);
                    this._utilityService.handleErrorResponse(err);
                });
        });
    }

    async saveMemberPaymentAll() {
        this.disableAll();
        this.showSpinner = true;
        //this.CheckSession(async () => {
        const control = this.paymentMethods.at(0);
        const cMPaymentTxnID = control.get('cMPaymentTxnID').value;
        if (cMPaymentTxnID == -1 || cMPaymentTxnID == 0) {
            this._notifyService.showError("Please choose a valid payment Source.", "", 10000);
            this.Log(`A valid payment source was not chosen when Applying to All Fees`);
            this.enableAll();
            this.showSpinner = false;
            return;
        }

        this.Log('<b>Apply to All Fees</b> clicked.');
        let memCount = this.memberFees.length - 1;

        this.memberFees.forEach(async (itemFee, i) => {
            const fee = itemFee;
            this.cmPaymentItem.cMContractFeeID = fee?.cmContractFeeID;
            this.cmPaymentItem.cMMemberFeeID = fee?.cmMemberFeeID;
            this.cmPaymentItem.cMPaymentItemID = 0;
            this.cmPaymentItem.cMPaymentTxnID = cMPaymentTxnID;
            this.cmPaymentItem.feeTotal = parseFloat(fee.feeTotal.toFixed(2));
            this.cmPaymentItem.isPaymentDone = false;
            await this._paymentService.CMPaymentItem_Create(this.encryptedUser, this.cmPaymentItem)
                .then(async (result: SimpleResponse) => {
                    if (result?.statusCode == 1) {
                        if (memCount == i) {
                            this._notifyService.showSuccess(`The ${fee?.cmFeeName} payment was saved successfully`, "", 7000)

                            let txn: CMPaymentTxn = this.paySourceDD.find(s => s.cMPaymentTxnID == cMPaymentTxnID);
                            let details = '';

                            if (txn) {
                                details = `Details: ${txn.paymentMethodSummary}. Allow other members to use: ${txn.isAllowOtherMem}`;
                            }

                            this.Log(`Payments: ${fee?.cmFeeName} payment for ${fee.feeTotal} payment method was saved. ${details}`);

                            this.CMPaymentItem_Get(this.cmPaymentItem?.cMMemberFeeID);
                            await this.getMemberFee(this.memberId, true);
                            await this.checkIfApplyAllSuccess();
                            await this.enableAll();
                        }
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.enableAll();
                    this.showSpinner = false
                    this._globalService.error("cm-contract-client.saveMemberPaymentAll", err.message, null);
                    this._utilityService.handleErrorResponse(err);
                    this.Log(`Payments: ${fee?.cmFeeName} payment for ${fee.feeTotal} was not saved ${err.message}.`);
                });
        });
        //}

        this.showSpinner = false;

    }

    async checkIfApplyAllSuccess() {
        const control = this.paymentMethods.at(0);
        const cMPaymentTxnID = control.get('cMPaymentTxnID').value;
        for (let i = 0; i < this.memberFees?.length; i++) {
            if (!this.memberFees[i]?.isDone) {
                const fee = this.memberFees[i];
                this.cmPaymentItem.cMContractFeeID = fee?.cmContractFeeID;
                this.cmPaymentItem.cMMemberFeeID = fee?.cmMemberFeeID;
                this.cmPaymentItem.cMPaymentItemID = 0;
                this.cmPaymentItem.cMPaymentTxnID = cMPaymentTxnID;
                this.cmPaymentItem.feeTotal = parseFloat(fee.feeTotal.toFixed(2));
                this.cmPaymentItem.isPaymentDone = false;
                await this._paymentService.CMPaymentItem_Create(this.encryptedUser, this.cmPaymentItem)
                    .then(async (result: SimpleResponse) => {
                        if (result?.statusCode == 1) {
                            this.Log(`${fee?.cmFeeName} payment for ${fee.feeTotal} was saved.`);
                        }
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.enableAll();
                        this.showSpinner = false;
                        this._globalService.error("cm-contract-client.checkIfApplyAllSuccess", err.message, null);
                        this._utilityService.handleErrorResponse(err);
                        this.Log(`${fee?.cmFeeName} payment for ${fee.feeTotal} was not saved ${err.message}.`);
                    });
                break;
            }
        }
        this.enableAll();
        this.showSpinner = false;
    }

    disableAll() {
        $(':button').prop('disabled', true);
    }

    enableAll() {
        $(':button').prop('disabled', false);
        $('#addPayBtn').prop('disabled', true);
    }

    mergeMultipleCashCheckPays(payType) {

        const formArray = this.paymentForm.get('paymentMethods') as FormArray;
        let totalFeeAmount = 0;
        const filteredArray = formArray.controls.filter((control) => control.value.paymentType == payType);

        if (filteredArray.length > 0) {
            filteredArray.forEach((control) => {
                const feeAmountValue = this.changeToNumber(control.value.feeAmount);
                totalFeeAmount += feeAmountValue;
            });

            const mergedObject = {
                cMPaymentItemID: filteredArray[0].value.cMPaymentItemID,
                cMContractFeeID: 0,
                cMPaymentTxnID: [{
                    value: filteredArray[0].value.cMPaymentTxnID, disabled: filteredArray[0]?.value?.isPaymentDone
                }],
                feeAmount: [{
                    value: this.changeToCurrency(totalFeeAmount), disabled: filteredArray[0]?.value?.isPaymentDone
                }],
                paymentType: payType
            };

            formArray.controls = formArray.controls.filter((control) => control.value.paymentType != payType);

            formArray.push(this.fb.group(mergedObject));
        }

    }

    splitEvenly() {

        let splitAmount = ((this.memberFee.feeTotal) / this.paymentMethods.controls.length);
        this.paymentForm.get('paymentMethods')['controls'].forEach(mem => {
            mem.controls['feeAmount'].setValue(this.changeToCurrency(splitAmount))
        });

        this.onChangeAmount(false)
    }

    adjustPayControlValue(total?) {
        if (total > this.memberFee.feeTotal) {

            let diff = total - this.memberFee.feeTotal
            let value = this.changeToNumber(this.paymentMethods.at(this.paymentMethods?.length - 1).get("feeAmount").getRawValue()) - diff
            this.paymentMethods.at(this.paymentMethods?.length - 1).get("feeAmount").setValue(this.changeToCurrency(value))

        }
        if (total < this.memberFee.feeTotal) {

            let diff = this.memberFee.feeTotal - total
            let value = this.changeToNumber(this.paymentMethods.at(this.paymentMethods?.length - 1).get("feeAmount").getRawValue()) + diff
            this.paymentMethods.at(this.paymentMethods?.length - 1).get("feeAmount").setValue(this.changeToCurrency(value))

        }

        let amountTotal = 0
        this.paymentMethods.controls.forEach((item, index) => {
            amountTotal += this.changeToNumber(item.getRawValue().feeAmount);
        });
        this.displayBeingPaid = this.changeToCurrency(this.memberFee?.feeTotal - amountTotal)
    }

    confirmDelete(transactionId) {
        this.delTransId = transactionId;
        $('#deletePayConfirmation').modal('show');
    }

    async deleteCard() {
        await this._paymentService.CMPaymentTxn_Delete(this.encryptedUser, this.delTransId)
            .then(async (result: SimpleResponse) => {
                if (result?.statusCode == 1) {
                    this.cMPaymentTxn_Load();
                    $('#deletePayConfirmation').modal('hide');
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.deleteCard", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getPaymentReviews() {
        await this._contractService.GetPaymentReviews(this.encryptedUser, this.clpCompanyId, this.siteId, this.contractId, this.memberId)
            .then(async (result: PaymentReviewListResponse) => {
                if (result) {
                    if (result) {
                        let _paymentReview = UtilityService.clone(result);
                        this.paymentReview = UtilityService.clone(_paymentReview?.paymentReviews);
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.getPaymentReviews", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async saveReview() {
        this.CheckSession(async () => {
            this.navigationUpdate(eCMNavigation_Update_Type.isReview, true);

            await this.cMPaymentItem_Charge_Get(false);

            this.Log("Finish & Pay: <b>Accept & Sign</b> clicked in Review.");
        });
    }

    async onClickCharge(paymentItem: Pay) {
        this.CheckSession(async () => {
            let carIdx = this.paymentChargeItems.findIndex((item) => item?.cmPaymentTxnID == paymentItem?.cmPaymentTxnID);

            this.Log(`Finish & Pay: <b>Charge $${paymentItem.FeeTotal}</b> clicked.`);

            this.showSpinner = true

            let charge: Charge = {
                clpCompanyId: this.clpCompanyId,
                cmContractID: this.contractId,
                contactID: this.contactId,
                memberId: this.memberId,
                cmPaymentTxnID: paymentItem.cmPaymentTxnID,
                subFees: paymentItem.subFees
            }

            let total = this.totalToCharge(paymentItem.subFees, 'total');

            await this._paymentService.Charge(this.encryptedUser, charge)
                .then(async (result: SimpleResponse) => {
                    this.showSpinner = false
                    if (result?.messageBool) {
                        this._notifyService.showSuccess(`Your payment of $${this.formatNumber(total)} was successful.`, "Success", 7000)
                        this.Log(`Finish & Pay: Payment ${this.chargeFailed ? '(Retry)' : ''} of $${this.formatNumber(total)} was successful.`);

                        if (carIdx != -1) {
                            this.paymentChargeItems[carIdx].isPaymentDone = true;
                        }
                        await this.CMPaymentItem_isPaymentDone_Update(paymentItem.cmPaymentTxnID);

                        this.cMPaymentItem_Charge_Get(false);
                        this.verifyNonCashCharges();
                    }
                    else {
                        this._notifyService.showError(`Your payment of $${this.formatNumber(total)} was unsuccessful. ${result?.messageString2}`, "Issue", 10000);
                        this.chargeFailed = true;
                        this.Log(`Finish & Pay: Payment ${this.chargeFailed ? '(Retry)' : ''} of $${this.formatNumber(total)} was unsuccessful. ${result?.messageString2}`);
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.showSpinner = false
                    this._globalService.error("cm-contract-client.Charge", err.message, null);
                    this._utilityService.handleErrorResponse(err);
                    this.Log(`Finish & Pay: Payment ${this.chargeFailed ? '(Retry)' : ''} of $${this.formatNumber(total)} was unsuccessful. ${err.message}`);
                });
        });
    }



    verifyNonCashCharges() {
        if (this.userId == 0) {
            let bank_card_complete = true;
            this.paymentChargeItems.forEach(i => {
                if (i.paymentType <= 2 && !i.isPaymentDone) {
                    bank_card_complete = false;
                }
            });

            if (bank_card_complete) {
                this.paymentChargeItems.forEach(i => {
                    if (i.paymentType > 2 && !i.isPaymentDone) {
                        this.contactPaymentComplete = true;
                    }
                });
            }
        }
    }

    async cMPaymentItem_Charge_Get(isLoad) {
        await this._paymentService.cMPaymentItem_Charge_Get(this.encryptedUser, this.contractId, this.memberId)
            .then(async (result: PayListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.paymentChargeItems = response?.payList;
                    if (this.paymentChargeItems && this.paymentChargeItems.length > 0) {
                        let allCollectNowPaid = !this.paymentChargeItems.some(item => item?.isCollectNow && !item?.isPaymentDone);

                        if (allCollectNowPaid) {
                            this.isAllPayDone = true;
                        }
                        else {
                            this.isAllPayDone = false;
                            this.verifyNonCashCharges();
                        }
                    }
                    else {
                        this.isAllPayDone = true;//User with no payments should fully process;
                    }
                    if ((this.isAllPayDone && !isLoad)) {
                        this.navigationUpdate(eCMNavigation_Update_Type.isPaymentCollect, true);
                        if (this.paymentChargeItems.length > 0 && !this.paymentChargeItems.some(item => item.isCollectNow && !item.isPaymentDone)) {
                            this.showDivItem(this.stepper, '#tdDLUpload', '21', null, false, 3);
                            if (this.terminate) {
                                await this.navigationUpdate(eCMNavigation_Update_Type.isDLUploaded, true);
                                this.pay_download = false;
                            }
                        }
                        else if (this.paymentChargeItems.length == 0) {
                            this.showDivItem(this.stepper, '#tdDLUpload', '21', null, false, 3);

                            if (this.terminate) {
                                await this.navigationUpdate(eCMNavigation_Update_Type.isDLUploaded, true);
                            }
                        }
                        else if (this.paymentChargeItems.length > 0 && this.paymentChargeItems.some(item => item.isCollectNow && !item.isPaymentDone)) {
                            this.showDivItem(this.stepper, '#tdPay', '20', null, false, 3)
                        }

                        this.dtSignedMembers_Update();
                        this.cmMemberStatus(eREF_CMMemberStatus.Payment_Complete, null);

                        //if contract's current status is 3 then do this:
                        if (this.contract.statusID == 3) {
                            if (this.isContractReview) {
                                await this.cmContractStatus(eREF_CMContractStatus.OnHold_Review);
                            }
                            else {
                                await this.cmContractStatus(eREF_CMContractStatus.Waiting_CounterSign);
                            }
                        }

                        this.ProcessorContractPDFConvert_Add();
                    }
                    else if (!this.isAllPayDone && !isLoad) {
                        this.showDivItem(this.stepper, '#tdPay', '20', null, false, 3)
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.cMPaymentItem_Charge_Get", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async dtSignedMembers_Update() {
        await this._contractService.dtSignedMembers_Update(this.encryptedUser, this.contractId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.dtSignedMembers_Update", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async cMPaymentItem_Delete(fee, index) {
        await this._paymentService.cMPaymentItem_Delete(this.encryptedUser, fee.value.cMPaymentItemID)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response) {
                        this.removePaymentMethod(fee, index)
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.cMPaymentItem_Delete", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async onChangeAmount_old(isFromInp, feeIndex?, payfee?) {

        if (isFromInp) {

            if (this.paymentMethods?.length > 1) {
                let devideFee = (this.memberFee?.feeTotal - this.changeToNumber(payfee?.value?.feeAmount)) / (this.paymentMethods?.length - 1)

                this.paymentMethods.controls.forEach((item, index) => {
                    if (index != feeIndex) {
                        item.get('feeAmount').setValue(this.changeToCurrency(devideFee))
                    }
                });
            }

        }

        let amountTotal = 0
        this.paymentMethods.controls.forEach((item, index) => {
            amountTotal += this.changeToNumber(item.getRawValue().feeAmount);
        });

        amountTotal = Number(amountTotal.toFixed(2));

        await this.adjustPayControlValue(amountTotal)
    }

    async onChangeAmount(isFromInp: boolean, triggeredIndex?: number) {
        if (!isFromInp) return;

        const controls = this.paymentMethods.controls;
        const totalFee = this.memberFee?.feeTotal || 0;
        const totalControls = controls.length;

        if (totalControls < 1) return;

        let currentSum = 0;
        let autoAdjustIndex = -1;

        // Determine which index to auto adjust:
        // Default to last if editing not last, otherwise adjust first
        if (triggeredIndex === totalControls - 1) {
            autoAdjustIndex = 0; // Editing last → adjust first
        } else {
            autoAdjustIndex = totalControls - 1; // Editing first or middle → adjust last
        }

        controls.forEach((ctrl, i) => {
            if (i !== autoAdjustIndex) {
                const val = this.changeToNumber(ctrl.get('feeAmount')?.value);
                currentSum += val;
            }
        });

        const remaining = +(totalFee - currentSum).toFixed(2);
        const newVal = remaining >= 0 ? remaining : 0;

        // Avoid triggering another change event
        const currentAutoVal = this.changeToNumber(controls[autoAdjustIndex].get('feeAmount')?.value);
        if (currentAutoVal !== newVal) {
            controls[autoAdjustIndex].get('feeAmount')?.setValue(newVal, { emitEvent: true });
        }

        // Optional: enforce hard cap
        this.capInputs(triggeredIndex, totalFee);

        // Total recalculation
        let amountTotal = 0;
        controls.forEach(item => {
            amountTotal += this.changeToNumber(item.getRawValue().feeAmount);
        });

        await this.adjustPayControlValue(Number(amountTotal.toFixed(2)));
    }


    capInputs(skipIndex: number, totalFee) {
        const controls = this.paymentMethods.controls;
        let total = 0;

        controls.forEach((ctrl, i) => {
            if (i === skipIndex) return;

            const val = parseFloat(ctrl.get('feeAmount')?.value);
            if (!isNaN(val)) total += val;
        });

        const current = parseFloat(controls[skipIndex].get('feeAmount')?.value);
        if (!isNaN(current) && total + current > totalFee) {
            controls[skipIndex].get('feeAmount')?.setValue(
                +(totalFee - total).toFixed(2)
            );
        }
    }


    async CMPaymentItem_isPaymentDone_Update(txnId) {

        await this._paymentService.CMPaymentItem_isPaymentDone_Update(this.encryptedUser, txnId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.CMPaymentItem_isPaymentDone_Update", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async ProcessorContractPDFConvert_Add() {
        await this._contractService.ProcessorContractPDFConvert_Add(this.encryptedUser, this.clpCompanyId, this.contractId, this.contactId, this.siteId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.getDownloadStatus();
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isForPreviewDownload = false
                this._globalService.error("cm-contract-client.ProcessorContractPDFConvert_Add", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async ProcessorContractPDFConvert_GET() {
        await this._contractService.ProcessorContractPDFConvert_Get(this.encryptedUser, this.clpCompanyId, this.contractId, this.contactId, this.siteId, false)
            .then(async (result: ContractPdfConvertContainer) => {
                if (result) {
                    this.contractPdfConvertContainer = UtilityService.clone(result);
                    if (this.contractPdfConvertContainer?.processed) {
                        clearTimeout(this.isSubscribe);
                        this.isDownload = true;
                        this.isPreviewDownloaded = true
                        if (this.isForPreviewDownload) {
                            this.downloadContract()
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this.isForPreviewDownload = false
                this._globalService.error("cm-contract-client.ProcessorContractPDFConvert_GET", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getDownloadStatus() {
        this.isSubscribe = this.addTimeout(() => {
            this.ProcessorContractPDFConvert_GET();
            this.getDownloadStatus();
        }, 7000)
    }

    async downloadContract() {
        this.isDownloaded = true;
        if (this.contractPdfConvertContainer?.processed) {
            await this._contractService.GetContractPDFAsync(this.encryptedUser, this.contractPdfConvertContainer?.fileName, this.contractPdfConvertContainer?.fileLength)
                .then((result: any) => {
                    if (result) {
                        let file = new Blob([result], { type: 'application/pdf' });
                        let fileURL = URL.createObjectURL(file);
                        let fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        if (this.contactDetails)
                            fileLink.download = this.contactDetails?.firstName + '_' + this.contactDetails?.lastName + "_Contracts";
                        else
                            fileLink.download = "ContractDocuments.pdf";

                        fileLink.click();
                        this.isDownloaded = false;
                        this.isForPreviewDownload = false;
                        this.Log(`${fileLink.download}.pdf downloaded.`);
                        //this.addTimeout(function () {
                        //    window.open(fileURL, '_blank');
                        //}, 1000);
                        $('#modalExportDocument').modal('hide');
                    } else {
                        this.isDownloaded = false;
                        this.isForPreviewDownload = false;
                        this.Log(`Contract document not downloaded.`);
                        this._notifyService.showError('An error occurred downloading your contract. Please contact your rep.', '', 10000);
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this.isDownloaded = false;
                    this.isForPreviewDownload = false
                    this._utilityService.handleErrorResponse(err);
                    $('#modalExportDocument').modal('hide');
                    $('#modalExportDocumentAzure').modal('hide');
                    this.Log(`Contract document not downloaded. ${err.message}`);
                });

        }
        else {
            this.isDownloaded = false;
            this.ProcessorContractPDFConvert_GET();
        }
    }

    disableReview() {
        for (var i = 0; i < this.contractNavList?.length; i++) {
            if (!this.contractNavList[i]?.isAccepted) {
                this.isAllDocAccepted = false;
                break;
            }
            else {
                this.isAllDocAccepted = true;
            }
        }

        let isDetailsAccepted = this.navigation?.isDetails
        if (isDetailsAccepted && this.isAllDocAccepted && this.isPaySetup) {
            return false;
        }
        return true;
    }

    async onPaySourceChange(event, i, payfee) {
        let value = event?.target?.value
        if (value == 0) {
            this.Log(`<b>Add New Payment Method</b> clicked.`);
            this.showModal();
            let lastPaySrcSelected = this.paymentState?.filter((item) => item?.cMPaymentItemID == payfee?.value?.cMPaymentItemID)[0];
            this.paymentMethods.at(i).get('cMPaymentTxnID').setValue(lastPaySrcSelected?.cMPaymentTxnID);
            return;
        }
        let payObj = this.paymentTrxs.filter((item) => item?.cMPaymentTxnID == payfee?.value?.cMPaymentTxnID)[0];
        this.paymentForm.get('paymentMethods')['controls'].forEach(mem => {
            if (payfee?.value?.cMPaymentTxnID == mem?.value?.cMPaymentTxnID) {
                mem.controls['paymentType'].setValue(payObj?.paymentType);
            }
        });

        this.holdPayState()
    }

    mobileMenu() {
        this.toggleMobileMenu = !this.toggleMobileMenu;
        let menu = document.getElementById("mobileMenu") as HTMLElement;
        if (menu) {
            menu.classList.toggle("mobile-menu");
        }
    }

    hideEditCardModal() {
        $('#editCardModal').modal('hide');
    }

    hideEditBankModal() {
        $('#editBankModal').modal('hide');
    }

    async onEditCard(paymentItem: Pay) {
        this.CheckSession(async () => {
            this.payType = 'card'
            let card = this.paymentChargeItems.filter((item) => item?.cmPaymentTxnID == paymentItem?.cmPaymentTxnID)[0]

            //open up the Card edit screen (no cash or check or bank option);
            //if card reentered is the same last 4 as the earlier one, then call _stripeService.UpdateCreditCard else call _stripeService.AddCreditCard and update VPaymentMethodId on CMPaymentTxn

            this.ccForm = this.prepareCCForm();
            this.ccForm.reset();
            await this.retrieveCreditCard(card?.cmPaymentTxnID);
            this.Log('<b>Update Card</b> clicked.');

            this.ccForm.patchValue({
                creditCard: "",
                name: `${this.contactDetails?.firstName} ${this.contactDetails?.lastName}`,
                address: this.contactDetails?.add1,
                zipcode: this.contactDetails?.zip,
                phone: this.contactDetails?.mobile,
                email: this.contactDetails?.email,
                city: this.contactDetails?.city,
                state: this.contactDetails?.state,
                country: this.contactDetails?.country ? this.contactDetails?.country != 'US' ? 'US' : this.contactDetails?.country : '0',
                isAllowOtherMem: false
            });
        });
    }

    async onEditBank(paymentItem: Pay) {
        this.CheckSession(async () => {
            this.payType = 'bank'
            let bank = this.paymentChargeItems.filter((item) => item?.cmPaymentTxnID == paymentItem?.cmPaymentTxnID)[0]

            //open up the Card edit screen (no cash or check or bank option);
            //if card reentered is the same last 4 as the earlier one, then call _stripeService.UpdateCreditCard else call _stripeService.AddCreditCard and update VPaymentMethodId on CMPaymentTxn

            this.bankForm = this.prepareBankForm();
            this.bankForm.reset();
            await this.retrieveBank(bank?.cmPaymentTxnID);
            this.Log('<b>Update Bank</b> clicked.');

            this.bankForm.patchValue({
                accountName: `${this.contactDetails?.firstName} ${this.contactDetails?.lastName}`,
                accountAddress: this.contactDetails?.add1,
                accountZip: this.contactDetails?.zip,
                accountPhone: this.contactDetails?.mobile,
                accountEmail: this.contactDetails?.email,
                accountCity: this.contactDetails?.city,
                accountState: this.contactDetails?.state,
                accountCountry: this.contactDetails?.country ? this.contactDetails?.country != 'US' ? 'US' : this.contactDetails?.country : 'US',
                accountType: 'personal'
            });
        });
    }

    async retrieveCreditCard(cmpaymentTxnID: number) {
        this.editCardPayTxnId = cmpaymentTxnID
        await this._paymentService.retrieveCreditCard(this.encryptedUser, this.contractId, this.contactId, cmpaymentTxnID, this.vendorCustomerId)
            .then(async (result: RetrieveCardResponse) => {
                if (result?.cardDetails) {
                    let response = UtilityService.clone(result);
                    this.editCardDetails = response?.cardDetails
                    $('#editCardModal').modal('show');
                }
                else {
                    this._notifyService.showError("The card details could not be loaded. Please try again.", "", 10000)
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.retrieveCreditCard", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async retrieveBank(cmpaymentTxnID: number) {
        this.editCardPayTxnId = cmpaymentTxnID
        await this._paymentService.retrieveBank(this.encryptedUser, this.contractId, this.contactId, cmpaymentTxnID, this.vendorCustomerId)
            .then(async (result: RetrieveBankResponse) => {
                if (result?.messageBool) {
                    $('#editBankModal').modal('show');
                }
                else {
                    this._notifyService.showError("The bank details could not be loaded. Please try again.", "", 10000)
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.retrieveBank", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async onUpdateCreditCard() {
        this.CheckSession(async () => {
            let cc: CC = {
                contactId: this.contactId,
                cmMemberId: this.memberId,
                contractId: this.contractId,
                vCustomerId: this.vendorCustomerId,
                vCustomerId2: this.vendorCustomerId2,
                vCustomerIdPrimary: this.vCustomerIdPrimary,
                memberFeeId: this.memberFeeId,
                total: 0,
                creditCard: this.creditcardform.creditCard.value,
                name: this.creditcardform.name.value,
                exp: this.creditcardform.exp.value,
                cvc: this.creditcardform.cvc.value,
                address: this.creditcardform.address.value,
                zipcode: this.creditcardform.zipcode.value,
                phone: this.creditcardform.phone.value,
                email: this.creditcardform.email.value,
                city: this.creditcardform.city.value,
                state: this.creditcardform.state.value,
                country: this.creditcardform.country.value,
                txnId: this.editCardPayTxnId,
                isAllowOtherMem: (this.creditcardform.isAllowOtherMem.value) ? this.creditcardform.isAllowOtherMem.value : false
            }

            if (cc.isAllowOtherMem) {
                this.Log('<b>Allow this card to be used by other members</b> enabled.');
            }

            let last4digits = cc?.creditCard?.trim()?.slice(-4);
            let month = parseInt(cc?.exp.substring(0, 2), 10);
            let year = +`20${cc?.exp.substring(2)}`;
            if (last4digits == this.editCardDetails?.last4 && month == this.editCardDetails?.exp_month && year == this.editCardDetails?.exp_year) {
                await this.updateCreditCard(cc) //only updates billing information
            }
            else {
                await this.verifyCreditCard(cc);
            }
        });
    }

    async onUpdateBank() {
        this.CheckSession(async () => {
            let bank: Bank = {
                contactId: this.contactId,
                cmMemberId: this.memberId,
                contractId: this.contractId,
                memberFeeId: this.memberFeeId,
                vCustomerId: this.vendorCustomerId,
                vCustomerId2: this.vendorCustomerId2,
                total: 0,
                routingNumber: this.bankform.routingNumber.value,
                accountNumber: this.bankform.accountNumber.value,
                accountType: this.bankform.accountType.value,
                institution: this.bankform.institution.value,
                businessName: this.bankform.businessName.value,
                accountName: this.bankform.accountName.value,
                accountPhone: this.bankform.accountPhone.value,
                accountEmail: this.bankform.accountEmail.value,
                accountAddress: this.bankform.accountAddress.value,
                accountCity: this.bankform.accountCity.value,
                accountZip: this.bankform.accountZip.value,
                accountState: this.bankform.accountState.value,
                accountCountry: this.bankform.accountCountry.value,
                txnId: this.editCardPayTxnId
            }

            await this.verifyBankAccount(bank);
        });
    }

    async updateCreditCard(cc) {
        this.showSpinner = true;
        await this._paymentService.updateCreditCard(this.encryptedUser, cc, this.contactId, this.editCardPayTxnId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        this._notifyService.showSuccess("The credit card was updated successfully.", "Success", 7000)
                        this.hideEditCardModal();
                        this.cMPaymentItem_Charge_Get(true);
                    }
                    else {
                        this._notifyService.showError("The credit card could not be updated. Please try again.", "Error", 10000);
                    }
                }
                this.showSpinner = false
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false
                this._globalService.error("cm-contract-client.CMPaymentItem_isPaymentDone_Update", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    formatNumber(number) {
        let fixed = number.toFixed(2);
        let parts = fixed.split('.');

        let int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        let formatted = int + '.' + parts[1];

        return formatted;
    }

    getFormattedDate(date: string) {
        if (date) {
            let d = new Date(date);
            let curr_date = d.getDate();
            let curr_month = d.getMonth() + 1; //Months are zero based
            let curr_year = d.getFullYear();
            return curr_month + "/" + curr_date + "/" + curr_year;
        }
        else
            return '';
    }

    async Log(message: string) {
        let log: CMContractLog = {
            sessionID: this.sessionId,
            clpUserID: !this.is_client ? this.user?.cLPUserID : 0,
            sclpUserID: this.user?.slurpyUserId > 0 ? this.user?.slurpyUserId : 0,
            contactID: this.contactId,
            cmContractID: this.contractId,
            isFaceToFace: !this.is_client ? 1 : 0,
            notes: message
        }
        await this._contractService.CMContractLog_Create(this.encryptedUser, log)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.Log", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    previewUrlFront: string | ArrayBuffer | null = null;
    previewUrlBack: string | ArrayBuffer | null = null;


    onFileSelect(event: SelectEvent, type: string): void {

        const file = event.files[0].rawFile as File;

        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            if (file.type.startsWith('image/')) {
                if (type == 'front') {
                    this.dlFront = file
                    if (!this.isValidFile(this.dlFront)) {
                        this.previewUrlFront = null;
                        return;
                    }
                    if (this.dlFront.size > 5242880) {
                        this.dlFront = null;
                        this._notifyService.showError("File size too large Please upload file less than 5MB.", "Error", 10000)
                        return;
                    }
                    reader.onload = () => {
                        this.previewUrlFront = reader.result;
                    };
                }
                else {
                    this.dlBack = file
                    if (!this.isValidFile(this.dlBack)) {
                        this.previewUrlBack = null;
                        return;
                    }
                    if (this.dlBack.size > 5242880) {
                        this.dlBack = null;
                        this._notifyService.showError("File size too large Please upload file less than 5MB.", "Error", 10000)
                        return;
                    }
                    reader.onload = () => {
                        this.previewUrlBack = reader.result;
                    };
                }
            }
            else {
                if (type == 'front') {
                    this.dlFront = null;
                    this.previewUrlFront = null;
                }
                else {
                    this.dlBack = null;
                    this.previewUrlBack = null;
                }
                this._notifyService.showError("Please upload a valid image file.", "Error", 10000)
            }

        }
    }

    isValidFile(file: any): boolean {
        const allowedExtensions = ['jpg', 'jpeg', 'png', 'bmp'];
        const type: string = file.type.toLowerCase();
        let extension = type.split('/')[1];
        return allowedExtensions.includes(extension);
    }

    async uploadDL() {
        let formData = new FormData();
        if (!this.dlFront) {
            return this._notifyService.showError("Please upload front side of DL.", "Error", 10000)
        }
        if (!this.dlBack) {
            return this._notifyService.showError("Please upload back side of DL.", "Error", 10000)
        }
        formData.append('dlFront', this.dlFront, this.dlFront.name);
        formData.append('dlBack', this.dlBack, this.dlBack.name);

        this.showSpinner = true;
        await this._contractService.CM_MemberDLFileUpload(this.encryptedUser, formData, this.contractId, this.clpCompanyId, this.memberId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                        this.Log(`Member status changed to <b>Uploaded_Drivers_License</b>`);
                        this.CMContract_CheckMemberDL();
                        this.dtSignedMembers_Update();
                        this._notifyService.showSuccess("Driving license uploaded successfully.", "Success", 7000)
                        await this.navigationUpdate(eCMNavigation_Update_Type.isDLUploaded, true);
                    }
                }
                this.showSpinner = false;
            })
            .catch((err: HttpErrorResponse) => {
                this.showSpinner = false;
                this._globalService.error("cm-contract-client.Log", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async CMContract_CheckMemberDL() {
        await this._contractService.CMContract_CheckMemberDL(this.encryptedUser, this.contractId, this.clpCompanyId, this.contactId, this.siteId)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.Log", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async ContractOpenAutomation() {
        await this._contractService.ContractOpenAutomation(this.encryptedUser, this.clpCompanyId, this.contractId, this.contactId, this.is_client)
            .then(async (result: SimpleResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    if (response?.messageBool) {
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.Log", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getSiteData() {
        await this._clubService.Site_GetDD(this.encryptedUser, this.clpCompanyId, this.contactId).
            then(async (result: SiteDDListResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.siteList = response.sites;

                    if (this.classCode1) {
                        if (this.siteList.some(b => b.class1Code == this.classCode1) == true) {
                            this.site = this.siteList.filter(l => l.class1Code == this.classCode1)[0];
                            this.taxRate = this.site?.taxRate;
                        }
                    }
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-client.getSiteData", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    async getClubDetails() {
        await this._clubService.clubGetByID(this.encryptedUser, this.contract.clubID).
            then(async (result: CMClubResponse) => {
                if (result) {
                    var response = UtilityService.clone(result);
                    this.isContractReview = response.clubConfig?.isContractReview;
                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract.getClubDetails", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    totalToCharge(subFees: FeeItem[], type) {
        let total = 0;

        subFees.forEach(f => {
            switch (type) {
                case 'base':
                    total += f.feeBase;
                    break;
                case 'tax':
                    total += f.feeTax;
                    break;
                case 'surcharge':
                    total += f.feeSurcharge;
                    break;
                case 'total':
                    total += f.feeTotal;
                    break;
            }
        });

        return total;
    }

    get paymentMethods(): FormArray {
        return this.paymentForm.get("paymentMethods") as FormArray
    }

    get creditcardform() { return this.ccForm.controls; }

    get bankform() { return this.bankForm.controls; }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
